/*!
	Modaal - accessible modals - v0.4.4
	by Humaan, for all humans.
	http://humaan.com
 */
!function(a){function t(a){var t={},o=!1;a.attr("data-modaal-type")&&(o=!0,t.type=a.attr("data-modaal-type")),a.attr("data-modaal-content-source")&&(o=!0,t.content_source=a.attr("data-modaal-content-source")),a.attr("data-modaal-animation")&&(o=!0,t.animation=a.attr("data-modaal-animation")),a.attr("data-modaal-animation-speed")&&(o=!0,t.animation_speed=a.attr("data-modaal-animation-speed")),a.attr("data-modaal-after-callback-delay")&&(o=!0,t.after_callback_delay=a.attr("data-modaal-after-callback-delay")),a.attr("data-modaal-is-locked")&&(o=!0,t.is_locked="true"===a.attr("data-modaal-is-locked")),a.attr("data-modaal-hide-close")&&(o=!0,t.hide_close="true"===a.attr("data-modaal-hide-close")),a.attr("data-modaal-background")&&(o=!0,t.background=a.attr("data-modaal-background")),a.attr("data-modaal-overlay-opacity")&&(o=!0,t.overlay_opacity=a.attr("data-modaal-overlay-opacity")),a.attr("data-modaal-overlay-close")&&(o=!0,t.overlay_close="false"!==a.attr("data-modaal-overlay-close")),a.attr("data-modaal-accessible-title")&&(o=!0,t.accessible_title=a.attr("data-modaal-accessible-title")),a.attr("data-modaal-start-open")&&(o=!0,t.start_open="true"===a.attr("data-modaal-start-open")),a.attr("data-modaal-fullscreen")&&(o=!0,t.fullscreen="true"===a.attr("data-modaal-fullscreen")),a.attr("data-modaal-custom-class")&&(o=!0,t.custom_class=a.attr("data-modaal-custom-class")),a.attr("data-modaal-close-text")&&(o=!0,t.close_text=a.attr("data-modaal-close-text")),a.attr("data-modaal-close-aria-label")&&(o=!0,t.close_aria_label=a.attr("data-modaal-close-aria-label")),a.attr("data-modaal-background-scroll")&&(o=!0,t.background_scroll="true"===a.attr("data-modaal-background-scroll")),a.attr("data-modaal-width")&&(o=!0,t.width=parseInt(a.attr("data-modaal-width"))),a.attr("data-modaal-height")&&(o=!0,t.height=parseInt(a.attr("data-modaal-height"))),a.attr("data-modaal-confirm-button-text")&&(o=!0,t.confirm_button_text=a.attr("data-modaal-confirm-button-text")),a.attr("data-modaal-confirm-cancel-button-text")&&(o=!0,t.confirm_cancel_button_text=a.attr("data-modaal-confirm-cancel-button-text")),a.attr("data-modaal-confirm-title")&&(o=!0,t.confirm_title=a.attr("data-modaal-confirm-title")),a.attr("data-modaal-confirm-content")&&(o=!0,t.confirm_content=a.attr("data-modaal-confirm-content")),a.attr("data-modaal-gallery-active-class")&&(o=!0,t.gallery_active_class=a.attr("data-modaal-gallery-active-class")),a.attr("data-modaal-loading-content")&&(o=!0,t.loading_content=a.attr("data-modaal-loading-content")),a.attr("data-modaal-loading-class")&&(o=!0,t.loading_class=a.attr("data-modaal-loading-class")),a.attr("data-modaal-ajax-error-class")&&(o=!0,t.ajax_error_class=a.attr("data-modaal-ajax-error-class")),a.attr("data-modaal-instagram-id")&&(o=!0,t.instagram_id=a.attr("data-modaal-instagram-id")),o&&a.modaal(t);}var o={init:function(t,o){var e=this;if(e.dom=a("body"),e.$elem=a(o),e.options=a.extend({},a.fn.modaal.options,e.$elem.data(),t),e.xhr=null,e.scope={is_open:!1,id:"modaal_"+(new Date).getTime()+Math.random().toString(16).substring(2),source:e.options.content_source?e.options.content_source:e.$elem.attr("href")},e.$elem.attr("data-modaal-scope",e.scope.id),e.private_options={active_class:"is_active"},e.lastFocus=null,e.options.is_locked||"confirm"==e.options.type||e.options.hide_close?e.scope.close_btn="":e.scope.close_btn='<button type="button" class="modaal-close" id="modaal-close" aria-label="'+e.options.close_aria_label+'"><span>'+e.options.close_text+"</span></button>","none"===e.options.animation&&(e.options.animation_speed=0,e.options.after_callback_delay=0),a(o).on("click.Modaal",function(a){a.preventDefault(),e.create_modaal(e,a);}),!0===e.options.outer_controls){var i="outer";}else {var i="inner";}e.scope.prev_btn='<button type="button" class="modaal-gallery-control modaal-gallery-prev modaal-gallery-prev-'+i+'" id="modaal-gallery-prev" aria-label="Previous image (use left arrow to change)"><span>Previous Image</span></button>',e.scope.next_btn='<button type="button" class="modaal-gallery-control modaal-gallery-next modaal-gallery-next-'+i+'" id="modaal-gallery-next" aria-label="Next image (use right arrow to change)"><span>Next Image</span></button>',!0===e.options.start_open&&e.create_modaal(e);},create_modaal:function(a,t){var o,a=this;if(a.lastFocus=a.$elem,!1!==a.options.should_open&&("function"!=typeof a.options.should_open||!1!==a.options.should_open())){switch(a.options.before_open.call(a,t),a.options.type){case"inline":a.create_basic();break;case"ajax":o=a.options.source(a.$elem,a.scope.source),a.fetch_ajax(o);break;case"confirm":a.options.is_locked=!0,a.create_confirm();break;case"image":a.create_image();break;case"iframe":o=a.options.source(a.$elem,a.scope.source),a.create_iframe(o);break;case"video":a.create_video(a.scope.source);break;case"instagram":a.create_instagram();}a.watch_events();}},watch_events:function(){var t=this;t.dom.off("click.Modaal keyup.Modaal keydown.Modaal"),t.dom.on("keydown.Modaal",function(o){var e=o.keyCode,i=o.target;9==e&&t.scope.is_open&&(a.contains(document.getElementById(t.scope.id),i)||a("#"+t.scope.id).find('*[tabindex="0"]').focus());}),t.dom.on("keyup.Modaal",function(o){var e=o.keyCode,i=o.target;return o.shiftKey&&9==o.keyCode&&t.scope.is_open&&(a.contains(document.getElementById(t.scope.id),i)||a("#"+t.scope.id).find(".modaal-close").focus()),!t.options.is_locked&&27==e&&t.scope.is_open?!a(document.activeElement).is("input:not(:checkbox):not(:radio)")&&void t.modaal_close():"image"==t.options.type?(37==e&&t.scope.is_open&&!a("#"+t.scope.id+" .modaal-gallery-prev").hasClass("is_hidden")&&t.gallery_update("prev"),void(39==e&&t.scope.is_open&&!a("#"+t.scope.id+" .modaal-gallery-next").hasClass("is_hidden")&&t.gallery_update("next"))):void 0;}),t.dom.on("click.Modaal",function(o){var e=a(o.target);if(!t.options.is_locked&&(t.options.overlay_close&&e.is(".modaal-inner-wrapper")||e.is(".modaal-close")||e.closest(".modaal-close").length)){return void t.modaal_close();}if(e.is(".modaal-confirm-btn")){return e.is(".modaal-ok")&&t.options.confirm_callback.call(t,t.lastFocus),e.is(".modaal-cancel")&&t.options.confirm_cancel_callback.call(t,t.lastFocus),void t.modaal_close();}if(e.is(".modaal-gallery-control")){if(e.hasClass("is_hidden")){return;}return e.is(".modaal-gallery-prev")&&t.gallery_update("prev"),void(e.is(".modaal-gallery-next")&&t.gallery_update("next"));}});},build_modal:function(t){var o=this,e="";"instagram"==o.options.type&&(e=" modaal-instagram");var i,l="video"==o.options.type?"modaal-video-wrap":"modaal-content";switch(o.options.animation){case"fade":i=" modaal-start_fade";break;case"slide-down":i=" modaal-start_slidedown";break;default:i=" modaal-start_none";}var n="";o.options.fullscreen&&(n=" modaal-fullscreen"),""===o.options.custom_class&&void 0===o.options.custom_class||(o.options.custom_class=" "+o.options.custom_class);var s="";o.options.width&&o.options.height&&"number"==typeof o.options.width&&"number"==typeof o.options.height?s=' style="max-width:'+o.options.width+"px;height:"+o.options.height+'px;overflow:auto;"':o.options.width&&"number"==typeof o.options.width?s=' style="max-width:'+o.options.width+'px;"':o.options.height&&"number"==typeof o.options.height&&(s=' style="height:'+o.options.height+'px;overflow:auto;"'),("image"==o.options.type||"video"==o.options.type||"instagram"==o.options.type||o.options.fullscreen)&&(s="");var d="";o.is_touch()&&(d=' style="cursor:pointer;"');var r='<div class="modaal-wrapper modaal-'+o.options.type+i+e+n+o.options.custom_class+'" id="'+o.scope.id+'"><div class="modaal-outer-wrapper"><div class="modaal-inner-wrapper"'+d+">";"video"!=o.options.type&&(r+='<div class="modaal-container"'+s+">"),r+='<div class="'+l+' modaal-focus" aria-hidden="false" aria-label="'+o.options.accessible_title+" - "+o.options.close_aria_label+'" role="dialog">',"inline"==o.options.type?r+='<div class="modaal-content-container" role="document"></div>':r+=t,r+="</div>"+o.scope.close_btn,"video"!=o.options.type&&(r+="</div>"),r+="</div>","image"==o.options.type&&!0===o.options.outer_controls&&(r+=o.scope.prev_btn+o.scope.next_btn),r+="</div></div>",a("#"+o.scope.id+"_overlay").length<1&&o.dom.append(r),"inline"==o.options.type&&t.appendTo("#"+o.scope.id+" .modaal-content-container"),o.modaal_overlay("show");},create_basic:function(){var t=this,o=a(t.scope.source),e="";o.length?(e=o.contents().detach(),o.empty()):e="Content could not be loaded. Please check the source and try again.",t.build_modal(e);},create_instagram:function(){var t=this,o=t.options.instagram_id,e="",i="Instagram photo couldn't be loaded, please check the embed code and try again.";if(t.build_modal('<div class="modaal-content-container'+(""!=t.options.loading_class?" "+t.options.loading_class:"")+'">'+t.options.loading_content+"</div>"),""!=o&&null!==o&&void 0!==o){var l="https://api.instagram.com/oembed?url=http://instagr.am/p/"+o+"/";a.ajax({url:l,dataType:"jsonp",cache:!1,success:function(o){t.dom.append('<div id="temp-ig" style="width:0;height:0;overflow:hidden;">'+o.html+"</div>"),t.dom.attr("data-igloaded")?window.instgrm.Embeds.process():t.dom.attr("data-igloaded","true");var e="#"+t.scope.id+" .modaal-content-container";a(e).length>0&&setTimeout(function(){a("#temp-ig").contents().clone().appendTo(e),a("#temp-ig").remove();},1e3);},error:function(){e=i;var o=a("#"+t.scope.id+" .modaal-content-container");o.length>0&&(o.removeClass(t.options.loading_class).addClass(t.options.ajax_error_class),o.html(e));}});}else {e=i;}return!1;},fetch_ajax:function(t){var o=this;null==o.options.accessible_title&&(o.options.accessible_title="Dialog Window"),null!==o.xhr&&(o.xhr.abort(),o.xhr=null),o.build_modal('<div class="modaal-content-container'+(""!=o.options.loading_class?" "+o.options.loading_class:"")+'">'+o.options.loading_content+"</div>"),o.xhr=a.ajax(t,{success:function(t){var e=a("#"+o.scope.id).find(".modaal-content-container");e.length>0&&(e.removeClass(o.options.loading_class),e.html(t),o.options.ajax_success.call(o,e));},error:function(t){if("abort"!=t.statusText){var e=a("#"+o.scope.id+" .modaal-content-container");e.length>0&&(e.removeClass(o.options.loading_class).addClass(o.options.ajax_error_class),e.html("Content could not be loaded. Please check the source and try again."));}}});},create_confirm:function(){var a,t=this;a='<div class="modaal-content-container"><h1 id="modaal-title">'+t.options.confirm_title+'</h1><div class="modaal-confirm-content">'+t.options.confirm_content+'</div><div class="modaal-confirm-wrap"><button type="button" class="modaal-confirm-btn modaal-ok" aria-label="Confirm">'+t.options.confirm_button_text+'</button><button type="button" class="modaal-confirm-btn modaal-cancel" aria-label="Cancel">'+t.options.confirm_cancel_button_text+"</button></div></div></div>",t.build_modal(a);},create_image:function(){var t,o,e=this,i="";if(e.$elem.is("[data-group]")||e.$elem.is("[rel]")){var l=e.$elem.is("[data-group]"),n=l?e.$elem.attr("data-group"):e.$elem.attr("rel"),s=a(l?'[data-group="'+n+'"]':'[rel="'+n+'"]');s.removeAttr("data-gallery-active","is_active"),e.$elem.attr("data-gallery-active","is_active"),o=s.length-1;var d=[];i='<div class="modaal-gallery-item-wrap">',s.each(function(t,o){var e="",i="",l="",n=!1,s=!1,r=o.getAttribute("data-modaal-desc"),c=o.getAttribute("data-gallery-active");a(o).attr("data-modaal-content-source")?e=a(o).attr("data-modaal-content-source"):a(o).attr("href")?e=a(o).attr("href"):a(o).attr("src")?e=a(o).attr("src"):(e="trigger requires href or data-modaal-content-source attribute",s=!0),""!=r&&null!==r&&void 0!==r?(i=r,l='<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image '+(t+1)+" - </span>"+r.replace(/</g,"&lt;").replace(/>/g,"&gt;")+"</div>"):l='<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image '+(t+1)+"</span></div>",c&&(n=!0);var m={url:e,alt:i,rawdesc:r,desc:l,active:n,src_error:s};d.push(m);});for(var r=0;r<d.length;r++){var c="",m=d[r].rawdesc?"Image: "+d[r].rawdesc:"Image "+r+" no description";d[r].active&&(c=" "+e.private_options.active_class);var p=d[r].src_error?d[r].url:'<img src="'+d[r].url+'" alt=" " style="width:100%">';i+='<div class="modaal-gallery-item gallery-item-'+r+c+'" aria-label="'+m+'">'+p+d[r].desc+"</div>";}i+="</div>",1!=e.options.outer_controls&&(i+=e.scope.prev_btn+e.scope.next_btn);}else{var u,_=!1;e.$elem.attr("data-modaal-content-source")?u=e.$elem.attr("data-modaal-content-source"):e.$elem.attr("href")?u=e.$elem.attr("href"):e.$elem.attr("src")?u=e.$elem.attr("src"):(u="trigger requires href or data-modaal-content-source attribute",_=!0);var v="",f="",m="";e.$elem.attr("data-modaal-desc")?(m=e.$elem.attr("data-modaal-desc"),v=e.$elem.attr("data-modaal-desc"),f='<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image - </span>'+v.replace(/</g,"&lt;").replace(/>/g,"&gt;")+"</div>"):m="Image with no description";var p=_?u:'<img src="'+u+'" alt=" " style="width:100%">';i='<div class="modaal-gallery-item is_active" aria-label="'+m+'">'+p+f+"</div>";}t=i,e.build_modal(t),a(".modaal-gallery-item.is_active").is(".gallery-item-0")&&a(".modaal-gallery-prev").hide(),a(".modaal-gallery-item.is_active").is(".gallery-item-"+o)&&a(".modaal-gallery-next").hide();},gallery_update:function(t){var o=this,e=a("#"+o.scope.id),i=e.find(".modaal-gallery-item"),l=i.length-1;if(0==l){return!1;}var n=e.find(".modaal-gallery-prev"),s=e.find(".modaal-gallery-next"),d=0,r=0,c=e.find(".modaal-gallery-item."+o.private_options.active_class),m="next"==t?c.next(".modaal-gallery-item"):c.prev(".modaal-gallery-item");return o.options.before_image_change.call(o,c,m),("prev"!=t||!e.find(".gallery-item-0").hasClass("is_active"))&&(("next"!=t||!e.find(".gallery-item-"+l).hasClass("is_active"))&&void c.stop().animate({opacity:0},250,function(){m.addClass("is_next").css({position:"absolute",display:"block",opacity:0});var t=a(document).width(),i=t>1140?280:50;d=e.find(".modaal-gallery-item.is_next").width(),r=e.find(".modaal-gallery-item.is_next").height();var p=e.find(".modaal-gallery-item.is_next img").prop("naturalWidth"),u=e.find(".modaal-gallery-item.is_next img").prop("naturalHeight");p>t-i?(d=t-i,e.find(".modaal-gallery-item.is_next").css({width:d}),e.find(".modaal-gallery-item.is_next img").css({width:d}),r=e.find(".modaal-gallery-item.is_next").find("img").height()):(d=p,r=u),e.find(".modaal-gallery-item-wrap").stop().animate({width:d,height:r},250,function(){c.removeClass(o.private_options.active_class+" "+o.options.gallery_active_class).removeAttr("style"),c.find("img").removeAttr("style"),m.addClass(o.private_options.active_class+" "+o.options.gallery_active_class).removeClass("is_next").css("position",""),m.stop().animate({opacity:1},250,function(){a(this).removeAttr("style").css({width:"100%"}),a(this).find("img").css("width","100%"),e.find(".modaal-gallery-item-wrap").removeAttr("style"),o.options.after_image_change.call(o,m);}),e.find(".modaal-gallery-item").removeAttr("tabindex"),e.find(".modaal-gallery-item."+o.private_options.active_class).attr("tabindex","0").focus(),e.find(".modaal-gallery-item."+o.private_options.active_class).is(".gallery-item-0")?n.stop().animate({opacity:0},150,function(){a(this).hide();}):n.stop().css({display:"block",opacity:n.css("opacity")}).animate({opacity:1},150),e.find(".modaal-gallery-item."+o.private_options.active_class).is(".gallery-item-"+l)?s.stop().animate({opacity:0},150,function(){a(this).hide();}):s.stop().css({display:"block",opacity:n.css("opacity")}).animate({opacity:1},150);});}));},create_video:function(a){var t,o=this;t='<iframe src="'+a+'" class="modaal-video-frame" frameborder="0" allowfullscreen></iframe>',o.build_modal('<div class="modaal-video-container">'+t+"</div>");},create_iframe:function(a){var t,o=this;t=null!==o.options.width||void 0!==o.options.width||null!==o.options.height||void 0!==o.options.height?'<iframe src="'+a+'" class="modaal-iframe-elem" frameborder="0" allowfullscreen></iframe>':'<div class="modaal-content-container">Please specify a width and height for your iframe</div>',o.build_modal(t);},modaal_open:function(){var t=this,o=a("#"+t.scope.id),e=t.options.animation;"none"===e&&(o.removeClass("modaal-start_none"),t.options.after_open.call(t,o)),"fade"===e&&o.removeClass("modaal-start_fade"),"slide-down"===e&&o.removeClass("modaal-start_slide_down");var i=o;a(".modaal-wrapper *[tabindex=0]").removeAttr("tabindex"),i="image"==t.options.type?a("#"+t.scope.id).find(".modaal-gallery-item."+t.private_options.active_class):o.find(".modaal-iframe-elem").length?o.find(".modaal-iframe-elem"):o.find(".modaal-video-wrap").length?o.find(".modaal-video-wrap"):o.find(".modaal-focus"),i.attr("tabindex","0").focus(),"none"!==e&&setTimeout(function(){t.options.after_open.call(t,o);},t.options.after_callback_delay);},modaal_close:function(){var t=this,o=a("#"+t.scope.id);t.options.before_close.call(t,o),null!==t.xhr&&(t.xhr.abort(),t.xhr=null),"none"===t.options.animation&&o.addClass("modaal-start_none"),"fade"===t.options.animation&&o.addClass("modaal-start_fade"),"slide-down"===t.options.animation&&o.addClass("modaal-start_slide_down"),setTimeout(function(){"inline"==t.options.type&&a("#"+t.scope.id+" .modaal-content-container").contents().detach().appendTo(t.scope.source),o.remove(),t.options.after_close.call(t),t.scope.is_open=!1;},t.options.after_callback_delay),t.modaal_overlay("hide"),null!=t.lastFocus&&t.lastFocus.focus();},modaal_overlay:function(t){var o=this;"show"==t?(o.scope.is_open=!0,o.options.background_scroll||o.dom.addClass("modaal-noscroll"),a("#"+o.scope.id+"_overlay").length<1&&o.dom.append('<div class="modaal-overlay" id="'+o.scope.id+'_overlay"></div>'),a("#"+o.scope.id+"_overlay").css("background",o.options.background).stop().animate({opacity:o.options.overlay_opacity},o.options.animation_speed,function(){o.modaal_open();})):"hide"==t&&a("#"+o.scope.id+"_overlay").stop().animate({opacity:0},o.options.animation_speed,function(){a(this).remove(),o.dom.removeClass("modaal-noscroll");});},is_touch:function(){return"ontouchstart"in window||navigator.maxTouchPoints;}},e=[];a.fn.modaal=function(t){return this.each(function(i){var l=a(this).data("modaal");if(l){if("string"==typeof t){switch(t){case"open":l.create_modaal(l);break;case"close":l.modaal_close();}}}else{var n=Object.create(o);n.init(t,this),a.data(this,"modaal",n),e.push({element:a(this).attr("class"),options:t});}});},a.fn.modaal.options={type:"inline",content_source:null,animation:"fade",animation_speed:300,after_callback_delay:350,is_locked:!1,hide_close:!1,background:"#000",overlay_opacity:"0.8",overlay_close:!0,accessible_title:"Dialog Window",start_open:!1,fullscreen:!1,custom_class:"",background_scroll:!1,should_open:!0,close_text:"Close",close_aria_label:"Close (Press escape to close)",width:null,height:null,before_open:function(){},after_open:function(){},before_close:function(){},after_close:function(){},source:function(a,t){return t;},confirm_button_text:"Confirm",confirm_cancel_button_text:"Cancel",confirm_title:"Confirm Title",confirm_content:"<p>This is the default confirm dialog content. Replace me through the options</p>",confirm_callback:function(){},confirm_cancel_callback:function(){},gallery_active_class:"gallery_active_item",outer_controls:!1,before_image_change:function(a,t){},after_image_change:function(a){},loading_content:'<div class="modaal-loading-spinner"><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div>',loading_class:"is_loading",ajax_error_class:"modaal-error",ajax_success:function(){},instagram_id:null},a(function(){var o=a(".modaal");o.length&&o.each(function(){t(a(this));});var i=new MutationObserver(function(o){o.forEach(function(o){if(o.addedNodes&&o.addedNodes.length>0){[].some.call(o.addedNodes,function(o){var i=a(o);(i.is("a")||i.is("button"))&&(i.hasClass("modaal")?t(i):e.forEach(function(t){if(t.element==i.attr("class")){return a(i).modaal(t.options),!1;}}));});}});}),l={subtree:!0,attributes:!0,childList:!0,characterData:!0};setTimeout(function(){i.observe(document.body,l);},500);});}(jQuery,window,document);

//-------------------------------------------------
//		youtube playlist jquery plugin
//		Created by dan@geckonm.com
//		www.geckonewmedia.com
//
//		v1.1 - updated to allow fullscreen 
//			 - thanks Ashraf for the request
//-------------------------------------------------
//modified by Geonetric to include iframe instead of old embed code.

jQuery.fn.ytplaylist = function (options) {

	// default settings
	var options = jQuery.extend({
		holderId: 'yt_holder',
		playerHeight: '300',
		playerWidth: '450',
		addThumbs: false,
		thumbSize: 'small',
		showInline: false,
		autoPlay: false,
		showRelated: false,
		allowFullScreen: true
	}, options);

	return this.each(function () {

		var selector = $(this);

		var autoPlay = "";
		var showRelated = "?rel=0";
		var fullScreen = "";
		if (options.autoPlay) autoPlay = "&autoplay=1";
		if (options.showRelated) showRelated = "?rel=1";
		if (options.allowFullScreen) fullScreen = "allowfullscreen";

		//throw a youtube player in
		function play(id) {
			var html = '';

			html += '<iframe height="' + options.playerHeight + '" width="' + options.playerWidth + '" frameborder="0" src="//www.youtube-nocookie.com/embed/' + id + showRelated + autoPlay + '" ' + fullScreen + '></iframe>';

			return html;

		};


		//grab a youtube id from a (clean, no querystring) url (thanks to http://jquery-howto.blogspot.com/2009/05/jyoutube-jquery-youtube-thumbnail.html)
		function youtubeid(url) {
			if (url.indexOf("watch") >= 0) {
				var ytid = url.match("[\\?&]v=([^&#]*)");
				ytid = ytid[1];
				return ytid;
			} else {
				var ytid = url.split('/');
				ytid = ytid[3];
				return ytid;
			}
		};


		//load inital video
		var firstVid = selector.children("li:first-child").addClass("currentvideo").children("a").attr("href");
		$("#" + options.holderId + "").html(play(youtubeid(firstVid)));

		//load video on request
		selector.children("li").children("a").click(function () {

			if (options.showInline) {
				$("li.currentvideo").removeClass("currentvideo");
				$(this).parent("li").addClass("currentvideo").html(play(youtubeid($(this).attr("href"))));
			}
			else {
				$("#" + options.holderId + "").html(play(youtubeid($(this).attr("href"))));
				$(this).parent().parent("ul").find("li.currentvideo").removeClass("currentvideo");
				$(this).parent("li").addClass("currentvideo");
			}



			return false;
		});

		//do we want thumbs with that?
		if (options.addThumbs) {

			selector.children().each(function (i) {

				var replacedText = $(this).children('a').text();

				if (options.thumbSize == 'small') {
					var thumbUrl = "http://img.youtube.com/vi/" + youtubeid($(this).children("a").attr("href")) + "/2.jpg";
				}
				else {
					var thumbUrl = "http://img.youtube.com/vi/" + youtubeid($(this).children("a").attr("href")) + "/0.jpg";
				}

				$(this).children("a").empty().html("<img src='" + thumbUrl + "' alt='' />" + replacedText);

			});

		}



	});

}; /* END youtube playlist */

/*
       (accessible)
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1@accessible360.1
  Author: Jason Webb (Accessible360)
 Website: https://accessible360.com
    Docs: https://accessible360.github.io/accessible-slick
    Repo: https://github.com/Accessible360/accessible-slick
  Issues: https://github.com/Accessible360/accessible-slick/issues

 */
  !function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(d){"use strict";var s,l=window.Slick||{};s=0,(l=function(i,e){var t,o=this;o.defaults={adaptiveHeight:!1,appendArrows:d(i),appendDots:d(i),arrows:!0,arrowsPlacement:null,asNavFor:null,prevArrow:'<button class="slick-prev" type="button"><span class="slick-prev-icon" aria-hidden="true"></span><span class="slick-sr-only">Previous</span></button>',nextArrow:'<button class="slick-next" type="button"><span class="slick-next-icon" aria-hidden="true"></span><span class="slick-sr-only">Next</span></button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(i,e){return d('<button type="button"><span class="slick-dot-icon" aria-hidden="true"></span><span class="slick-sr-only">Go to slide '+(e+1)+"</span></button>")},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,infinite:!0,initialSlide:0,instructionsText:null,lazyLoad:"ondemand",mobileFirst:!1,playIcon:'<span class="slick-play-icon" aria-hidden="true"></span>',pauseIcon:'<span class="slick-pause-icon" aria-hidden="true"></span>',pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,regionLabel:"carousel",respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useAutoplayToggleButton:!0,useCSS:!0,useGroupRole:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},o.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,$instructionsText:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$pauseButton:null,$pauseIcon:null,$playIcon:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},d.extend(o,o.initials),o.activeBreakpoint=null,o.animType=null,o.animProp=null,o.breakpoints=[],o.breakpointSettings=[],o.cssTransitions=!1,o.focussed=!1,o.interrupted=!1,o.hidden="hidden",o.paused=!0,o.positionProp=null,o.respondTo=null,o.rowCount=1,o.shouldClick=!0,o.$slider=d(i),o.$slidesCache=null,o.transformType=null,o.transitionType=null,o.visibilityChange="visibilitychange",o.windowWidth=0,o.windowTimer=null,t=d(i).data("slick")||{},o.options=d.extend({},o.defaults,e,t),o.currentSlide=o.options.initialSlide,o.originalSettings=o.options,void 0!==document.mozHidden?(o.hidden="mozHidden",o.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(o.hidden="webkitHidden",o.visibilityChange="webkitvisibilitychange"),o.autoPlay=d.proxy(o.autoPlay,o),o.autoPlayClear=d.proxy(o.autoPlayClear,o),o.autoPlayIterator=d.proxy(o.autoPlayIterator,o),o.autoPlayToggleHandler=d.proxy(o.autoPlayToggleHandler,o),o.changeSlide=d.proxy(o.changeSlide,o),o.clickHandler=d.proxy(o.clickHandler,o),o.selectHandler=d.proxy(o.selectHandler,o),o.setPosition=d.proxy(o.setPosition,o),o.swipeHandler=d.proxy(o.swipeHandler,o),o.dragHandler=d.proxy(o.dragHandler,o),o.instanceUid=s++,o.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,o.registerBreakpoints(),o.init(!0)}).prototype.addSlide=l.prototype.slickAdd=function(i,e,t){var o=this;if("boolean"==typeof e)t=e,e=null;else if(e<0||e>=o.slideCount)return!1;o.unload(),"number"==typeof e?0===e&&0===o.$slides.length?d(i).appendTo(o.$slideTrack):t?d(i).insertBefore(o.$slides.eq(e)):d(i).insertAfter(o.$slides.eq(e)):!0===t?d(i).prependTo(o.$slideTrack):d(i).appendTo(o.$slideTrack),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slides.each(function(i,e){d(e).attr("data-slick-index",i),d(e).attr("role","group"),d(e).attr("aria-label","slide "+i)}),o.$slidesCache=o.$slides,o.reinit()},l.prototype.animateHeight=function(){var i,e=this;1===e.options.slidesToShow&&!0===e.options.adaptiveHeight&&!1===e.options.vertical&&(i=e.$slides.eq(e.currentSlide).outerHeight(!0),e.$list.animate({height:i},e.options.speed))},l.prototype.animateSlide=function(i,e){var t={},o=this;o.animateHeight(),!0===o.options.rtl&&!1===o.options.vertical&&(i=-i),!1===o.transformsEnabled?!1===o.options.vertical?o.$slideTrack.animate({left:i},o.options.speed,o.options.easing,e):o.$slideTrack.animate({top:i},o.options.speed,o.options.easing,e):!1===o.cssTransitions?(!0===o.options.rtl&&(o.currentLeft=-o.currentLeft),d({animStart:o.currentLeft}).animate({animStart:i},{duration:o.options.speed,easing:o.options.easing,step:function(i){i=Math.ceil(i),!1===o.options.vertical?t[o.animType]="translate("+i+"px, 0px)":t[o.animType]="translate(0px,"+i+"px)",o.$slideTrack.css(t)},complete:function(){e&&e.call()}})):(o.applyTransition(),i=Math.ceil(i),!1===o.options.vertical?t[o.animType]="translate3d("+i+"px, 0px, 0px)":t[o.animType]="translate3d(0px,"+i+"px, 0px)",o.$slideTrack.css(t),e&&setTimeout(function(){o.disableTransition(),e.call()},o.options.speed))},l.prototype.getNavTarget=function(){var i=this.options.asNavFor;return i&&null!==i&&(i=d(i).not(this.$slider)),i},l.prototype.asNavFor=function(e){var i=this.getNavTarget();null!==i&&"object"==typeof i&&i.each(function(){var i=d(this).slick("getSlick");i.unslicked||i.slideHandler(e,!0)})},l.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},l.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},l.prototype.autoPlayClear=function(){this.autoPlayTimer&&clearInterval(this.autoPlayTimer)},l.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},l.prototype.autoPlayToggleHandler=function(){var i=this;i.paused?(i.$playIcon.css("display","none"),i.$pauseIcon.css("display","inline"),i.$pauseButton.find(".slick-play-text").attr("style","display: none"),i.$pauseButton.find(".slick-pause-text").removeAttr("style"),i.slickPlay()):(i.$playIcon.css("display","inline"),i.$pauseIcon.css("display","none"),i.$pauseButton.find(".slick-play-text").removeAttr("style"),i.$pauseButton.find(".slick-pause-text").attr("style","display: none"),i.slickPause())},l.prototype.buildArrows=function(){var i=this;if(!0===i.options.arrows)if(i.$prevArrow=d(i.options.prevArrow).addClass("slick-arrow"),i.$nextArrow=d(i.options.nextArrow).addClass("slick-arrow"),i.slideCount>i.options.slidesToShow){if(i.htmlExpr.test(i.options.prevArrow))if(null!=i.options.arrowsPlacement)switch(i.options.arrowsPlacement){case"beforeSlides":case"split":console.log("test"),i.$prevArrow.prependTo(i.options.appendArrows);break;case"afterSlides":i.$prevArrow.appendTo(i.options.appendArrows)}else i.$prevArrow.prependTo(i.options.appendArrows);if(i.htmlExpr.test(i.options.nextArrow))if(null!=i.options.arrowsPlacement)switch(i.options.arrowsPlacement){case"beforeSlides":console.log("test2"),i.$prevArrow.after(i.$nextArrow);break;case"afterSlides":case"split":i.$nextArrow.appendTo(i.options.appendArrows)}else i.$nextArrow.appendTo(i.options.appendArrows);!0!==i.options.infinite&&i.$prevArrow.addClass("slick-disabled").prop("disabled",!0)}else i.$prevArrow.add(i.$nextArrow).addClass("slick-hidden").prop("disabled",!0)},l.prototype.buildDots=function(){var i,e,t=this;if(!0===t.options.dots&&t.slideCount>t.options.slidesToShow){for(t.$slider.addClass("slick-dotted"),e=d("<ul />").addClass(t.options.dotsClass),i=0;i<=t.getDotCount();i+=1)e.append(d("<li />").append(t.options.customPaging.call(this,t,i)));t.$dots=e.appendTo(t.options.appendDots),t.$dots.find("li").first().addClass("slick-active")}},l.prototype.buildOut=function(){var t=this;t.$slides=t.$slider.children(t.options.slide+":not(.slick-cloned)").addClass("slick-slide"),t.slideCount=t.$slides.length,t.$slides.each(function(i,e){d(e).attr("data-slick-index",i).data("originalStyling",d(e).attr("style")||""),t.options.useGroupRole&&d(e).attr("role","group").attr("aria-label","slide "+(i+1))}),t.$slider.addClass("slick-slider"),t.$slider.attr("role","region"),t.$slider.attr("aria-label",t.options.regionLabel),t.$slideTrack=0===t.slideCount?d('<div class="slick-track"/>').appendTo(t.$slider):t.$slides.wrapAll('<div class="slick-track"/>').parent(),t.$list=t.$slideTrack.wrap('<div class="slick-list"/>').parent(),t.$slideTrack.css("opacity",0),!0!==t.options.centerMode&&!0!==t.options.swipeToSlide||(t.options.slidesToScroll=1),d("img[data-lazy]",t.$slider).not("[src]").addClass("slick-loading"),t.setupInfinite(),t.buildArrows(),t.buildDots(),t.updateDots(),t.setSlideClasses("number"==typeof t.currentSlide?t.currentSlide:0),!0===t.options.draggable&&t.$list.addClass("draggable"),t.options.autoplay&&t.options.useAutoplayToggleButton&&(t.$pauseIcon=d(t.options.pauseIcon).attr("aria-hidden",!0),t.$playIcon=d(t.options.playIcon).attr("aria-hidden",!0),t.$pauseButton=d('<button type="button" class="slick-autoplay-toggle-button">'),t.$pauseButton.append(t.$pauseIcon),t.$pauseButton.append(t.$playIcon.css("display","none")),t.$pauseButton.append(d('<span class="slick-pause-text slick-sr-only">Pause</span>')),t.$pauseButton.append(d('<span class="slick-play-text slick-sr-only" style="display: none">Play</span>')),t.$pauseButton.prependTo(t.$slider)),null!=t.options.instructionsText&&""!=t.options.instructionsText&&(t.$instructionsText=d('<p class="slick-instructions slick-sr-only">'+t.options.instructionsText+"</p>"),t.$instructionsText.prependTo(t.$slider))},l.prototype.buildRows=function(){var i,e,t,o=this,s=document.createDocumentFragment(),n=o.$slider.children();if(0<o.options.rows){for(t=o.options.slidesPerRow*o.options.rows,e=Math.ceil(n.length/t),i=0;i<e;i++){for(var l=document.createElement("div"),r=0;r<o.options.rows;r++){for(var a=document.createElement("div"),d=0;d<o.options.slidesPerRow;d++){var p=i*t+(r*o.options.slidesPerRow+d);n.get(p)&&a.appendChild(n.get(p))}l.appendChild(a)}s.appendChild(l)}o.$slider.empty().append(s),o.$slider.children().children().children().css({width:100/o.options.slidesPerRow+"%",display:"inline-block"})}},l.prototype.checkResponsive=function(i,e){var t,o,s,n=this,l=!1,r=n.$slider.width(),a=window.innerWidth||d(window).width();if("window"===n.respondTo?s=a:"slider"===n.respondTo?s=r:"min"===n.respondTo&&(s=Math.min(a,r)),n.options.responsive&&n.options.responsive.length&&null!==n.options.responsive){for(t in o=null,n.breakpoints)n.breakpoints.hasOwnProperty(t)&&(!1===n.originalSettings.mobileFirst?s<n.breakpoints[t]&&(o=n.breakpoints[t]):s>n.breakpoints[t]&&(o=n.breakpoints[t]));null!==o?null!==n.activeBreakpoint&&o===n.activeBreakpoint&&!e||(n.activeBreakpoint=o,"unslick"===n.breakpointSettings[o]?n.unslick(o):(n.options=d.extend({},n.originalSettings,n.breakpointSettings[o]),!0===i&&(n.currentSlide=n.options.initialSlide),n.refresh(i)),l=o):null!==n.activeBreakpoint&&(n.activeBreakpoint=null,n.options=n.originalSettings,!0===i&&(n.currentSlide=n.options.initialSlide),n.refresh(i),l=o),i||!1===l||n.$slider.trigger("breakpoint",[n,l])}},l.prototype.changeSlide=function(i,e){var t,o,s=this,n=d(i.currentTarget);switch(n.is("a")&&i.preventDefault(),n.is("li")||(n=n.closest("li")),t=s.slideCount%s.options.slidesToScroll!=0?0:(s.slideCount-s.currentSlide)%s.options.slidesToScroll,i.data.message){case"previous":o=0==t?s.options.slidesToScroll:s.options.slidesToShow-t,s.slideCount>s.options.slidesToShow&&s.slideHandler(s.currentSlide-o,!1,e);break;case"next":o=0==t?s.options.slidesToScroll:t,s.slideCount>s.options.slidesToShow&&s.slideHandler(s.currentSlide+o,!1,e);break;case"index":var l=0===i.data.index?0:i.data.index||n.index()*s.options.slidesToScroll;s.slideHandler(s.checkNavigable(l),!1,e),n.children().trigger("focus");break;default:return}},l.prototype.checkNavigable=function(i){var e=this.getNavigableIndexes(),t=0;if(i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},l.prototype.cleanUpEvents=function(){var i=this;i.options.autoplay&&i.options.useAutoplayToggleButton&&i.$pauseButton.off("click.slick",i.autoPlayToggleHandler),i.options.dots&&null!==i.$dots&&d("li",i.$dots).off("click.slick",i.changeSlide).off("mouseenter.slick",d.proxy(i.interrupt,i,!0)).off("mouseleave.slick",d.proxy(i.interrupt,i,!1)),i.$slider.off("focus.slick blur.slick"),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow&&i.$prevArrow.off("click.slick",i.changeSlide),i.$nextArrow&&i.$nextArrow.off("click.slick",i.changeSlide)),i.$list.off("touchstart.slick mousedown.slick",i.swipeHandler),i.$list.off("touchmove.slick mousemove.slick",i.swipeHandler),i.$list.off("touchend.slick mouseup.slick",i.swipeHandler),i.$list.off("touchcancel.slick mouseleave.slick",i.swipeHandler),i.$list.off("click.slick",i.clickHandler),d(document).off(i.visibilityChange,i.visibility),i.cleanUpSlideEvents(),d(window).off("orientationchange.slick.slick-"+i.instanceUid,i.orientationChange),d(window).off("resize.slick.slick-"+i.instanceUid,i.resize),d("[draggable!=true]",i.$slideTrack).off("dragstart",i.preventDefault),d(window).off("load.slick.slick-"+i.instanceUid,i.setPosition)},l.prototype.cleanUpSlideEvents=function(){var i=this;i.$list.off("mouseenter.slick",d.proxy(i.interrupt,i,!0)),i.$list.off("mouseleave.slick",d.proxy(i.interrupt,i,!1))},l.prototype.cleanUpRows=function(){var i;0<this.options.rows&&((i=this.$slides.children().children()).removeAttr("style"),this.$slider.empty().append(i))},l.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},l.prototype.destroy=function(i){var e=this;e.autoPlayClear(),e.touchObject={},e.cleanUpEvents(),d(".slick-cloned",e.$slider).detach(),e.options.autoplay&&e.options.useAutoplayToggleButton&&e.$pauseButton.remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.$prevArrow.length&&(e.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").prop("disabled",!1).css("display",""),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove()),e.$nextArrow&&e.$nextArrow.length&&(e.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").prop("disabled",!1).css("display",""),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove()),e.$slides&&(e.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){d(this).attr("style",d(this).data("originalStyling"))}),e.$slideTrack.children(this.options.slide).detach(),e.$slideTrack.detach(),e.$list.detach(),e.$slider.append(e.$slides)),e.cleanUpRows(),e.$slider.removeClass("slick-slider"),e.$slider.removeClass("slick-initialized"),e.$slider.removeClass("slick-dotted"),e.unslicked=!0,i||e.$slider.trigger("destroy",[e])},l.prototype.disableTransition=function(i){var e={};e[this.transitionType]="",!1===this.options.fade?this.$slideTrack.css(e):this.$slides.eq(i).css(e)},l.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},l.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},l.prototype.filterSlides=l.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},l.prototype.focusHandler=function(){var t=this;t.$slider.off("focus.slick blur.slick").on("focus.slick","*",function(i){var e=d(this);setTimeout(function(){t.options.pauseOnFocus&&e.is(":focus")&&(t.focussed=!0,t.autoPlay())},0)}).on("blur.slick","*",function(i){d(this);t.options.pauseOnFocus&&(t.focussed=!1,t.autoPlay())})},l.prototype.getCurrent=l.prototype.slickCurrentSlide=function(){return this.currentSlide},l.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},l.prototype.getLeft=function(i){var e,t,o,s,n=this,l=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),l=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(l=i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,l=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(l=n.slideOffset=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+l,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},l.prototype.getOption=l.prototype.slickGetOption=function(i){return this.options[i]},l.prototype.getNavigableIndexes=function(){for(var i=this,e=0,t=0,o=[],s=!1===i.options.infinite?i.slideCount:(e=-1*i.options.slidesToScroll,t=-1*i.options.slidesToScroll,2*i.slideCount);e<s;)o.push(e),e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;return o},l.prototype.getSlick=function(){return this},l.prototype.getSlideCount=function(){var s,n=this,i=!0===n.options.centerMode?Math.floor(n.$list.width()/2):0,l=-1*n.swipeLeft+i;return!0===n.options.swipeToSlide?(n.$slideTrack.find(".slick-slide").each(function(i,e){var t=d(e).outerWidth(),o=e.offsetLeft;if(!0!==n.options.centerMode&&(o+=t/2),l<o+t)return s=e,!1}),Math.abs(d(s).attr("data-slick-index")-n.currentSlide)||1):n.options.slidesToScroll},l.prototype.goTo=l.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},l.prototype.init=function(i){var e=this;d(e.$slider).hasClass("slick-initialized")||(d(e.$slider).addClass("slick-initialized"),e.buildRows(),e.buildOut(),e.setProps(),e.startLoad(),e.loadSlider(),e.initializeEvents(),e.updateArrows(),e.updateDots(),e.checkResponsive(!0),e.focusHandler()),i&&e.$slider.trigger("init",[e]),e.options.autoplay&&(e.paused=!1,e.autoPlay()),e.updateSlideVisibility(),null!=e.options.accessibility&&console.warn("accessibility setting is no longer supported."),null!=e.options.focusOnChange&&console.warn("focusOnChange is no longer supported."),null!=e.options.focusOnSelect&&console.warn("focusOnSelect is no longer supported.")},l.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide))},l.prototype.initDotEvents=function(){var i=this;!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&d("li",i.$dots).on("click.slick",{message:"index"},i.changeSlide),!0===i.options.dots&&!0===i.options.pauseOnDotsHover&&i.slideCount>i.options.slidesToShow&&d("li",i.$dots).on("mouseenter.slick",d.proxy(i.interrupt,i,!0)).on("mouseleave.slick",d.proxy(i.interrupt,i,!1))},l.prototype.initSlideEvents=function(){var i=this;i.options.pauseOnHover&&(i.$list.on("mouseenter.slick",d.proxy(i.interrupt,i,!0)),i.$list.on("mouseleave.slick",d.proxy(i.interrupt,i,!1)))},l.prototype.initializeEvents=function(){var i=this;i.initArrowEvents(),i.initDotEvents(),i.initSlideEvents(),i.options.autoplay&&i.options.useAutoplayToggleButton&&i.$pauseButton.on("click.slick",i.autoPlayToggleHandler),i.$list.on("touchstart.slick mousedown.slick",{action:"start"},i.swipeHandler),i.$list.on("touchmove.slick mousemove.slick",{action:"move"},i.swipeHandler),i.$list.on("touchend.slick mouseup.slick",{action:"end"},i.swipeHandler),i.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},i.swipeHandler),i.$list.on("click.slick",i.clickHandler),d(document).on(i.visibilityChange,d.proxy(i.visibility,i)),d(window).on("orientationchange.slick.slick-"+i.instanceUid,d.proxy(i.orientationChange,i)),d(window).on("resize.slick.slick-"+i.instanceUid,d.proxy(i.resize,i)),d("[draggable!=true]",i.$slideTrack).on("dragstart",i.preventDefault),d(window).on("load.slick.slick-"+i.instanceUid,i.setPosition),d(i.setPosition)},l.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},l.prototype.lazyLoad=function(){var i,e,t,n=this;function o(i){d("img[data-lazy]",i).each(function(){var i=d(this),e=d(this).attr("data-lazy"),t=d(this).attr("data-srcset"),o=d(this).attr("data-sizes")||n.$slider.attr("data-sizes"),s=document.createElement("img");s.onload=function(){i.animate({opacity:0},100,function(){t&&(i.attr("srcset",t),o&&i.attr("sizes",o)),i.attr("src",e).animate({opacity:1},200,function(){i.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,i,e])})},s.onerror=function(){i.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,i,e])},s.src=e})}if(!0===n.options.centerMode?t=!0===n.options.infinite?(e=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(e=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),n.options.slidesToShow/2+1+2+n.currentSlide):(e=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,t=Math.ceil(e+n.options.slidesToShow),!0===n.options.fade&&(0<e&&e--,t<=n.slideCount&&t++)),i=n.$slider.find(".slick-slide").slice(e,t),"anticipated"===n.options.lazyLoad)for(var s=e-1,l=t,r=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)s<0&&(s=n.slideCount-1),i=(i=i.add(r.eq(s))).add(r.eq(l)),s--,l++;o(i),n.slideCount<=n.options.slidesToShow?o(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?o(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&o(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},l.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},l.prototype.next=l.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},l.prototype.orientationChange=function(){this.checkResponsive(),this.setPosition()},l.prototype.pause=l.prototype.slickPause=function(){this.autoPlayClear(),this.paused=!0},l.prototype.play=l.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},l.prototype.postSlide=function(i){var e=this;e.unslicked||(e.$slider.trigger("afterChange",[e,i]),e.animating=!1,e.slideCount>e.options.slidesToShow&&e.setPosition(),e.swipeLeft=null,e.options.autoplay&&e.autoPlay(),e.updateSlideVisibility())},l.prototype.prev=l.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},l.prototype.preventDefault=function(i){i.preventDefault()},l.prototype.progressiveLazyLoad=function(i){i=i||1;var e,t,o,s,n,l=this,r=d("img[data-lazy]",l.$slider);r.length?(e=r.first(),t=e.attr("data-lazy"),o=e.attr("data-srcset"),s=e.attr("data-sizes")||l.$slider.attr("data-sizes"),(n=document.createElement("img")).onload=function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,e,t]),l.progressiveLazyLoad()},n.onerror=function(){i<3?setTimeout(function(){l.progressiveLazyLoad(i+1)},500):(e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,e,t]),l.progressiveLazyLoad())},n.src=t):l.$slider.trigger("allImagesLoaded",[l])},l.prototype.refresh=function(i){var e,t=this,o=t.slideCount-t.options.slidesToShow;!t.options.infinite&&t.currentSlide>o&&(t.currentSlide=o),t.slideCount<=t.options.slidesToShow&&(t.currentSlide=0),e=t.currentSlide,t.destroy(!0),d.extend(t,t.initials,{currentSlide:e}),t.init(),i||t.changeSlide({data:{message:"index",index:e}},!1)},l.prototype.registerBreakpoints=function(){var i,e,t,o=this,s=o.options.responsive||null;if("array"===d.type(s)&&s.length){for(i in o.respondTo=o.options.respondTo||"window",s)if(t=o.breakpoints.length-1,s.hasOwnProperty(i)){for(e=s[i].breakpoint;0<=t;)o.breakpoints[t]&&o.breakpoints[t]===e&&o.breakpoints.splice(t,1),t--;o.breakpoints.push(e),o.breakpointSettings[e]=s[i].settings}o.breakpoints.sort(function(i,e){return o.options.mobileFirst?i-e:e-i})}},l.prototype.reinit=function(){var i=this;i.$slides=i.$slideTrack.children(i.options.slide).addClass("slick-slide"),i.slideCount=i.$slides.length,i.currentSlide>=i.slideCount&&0!==i.currentSlide&&(i.currentSlide=i.currentSlide-i.options.slidesToScroll),i.slideCount<=i.options.slidesToShow&&(i.currentSlide=0),i.registerBreakpoints(),i.setProps(),i.setupInfinite(),i.buildArrows(),i.updateArrows(),i.initArrowEvents(),i.buildDots(),i.updateDots(),i.initDotEvents(),i.cleanUpSlideEvents(),i.initSlideEvents(),i.checkResponsive(!1,!0),i.setSlideClasses("number"==typeof i.currentSlide?i.currentSlide:0),i.setPosition(),i.focusHandler(),i.paused=!i.options.autoplay,i.autoPlay(),i.$slider.trigger("reInit",[i])},l.prototype.resize=function(){var i=this;d(window).width()!==i.windowWidth&&(clearTimeout(i.windowDelay),i.windowDelay=window.setTimeout(function(){i.windowWidth=d(window).width(),i.checkResponsive(),i.unslicked||i.setPosition()},50))},l.prototype.removeSlide=l.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},l.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled||(!(s={})===o.cssTransitions?s[o.animType]="translate("+e+", "+t+")":s[o.animType]="translate3d("+e+", "+t+", 0px)"),o.$slideTrack.css(s)},l.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},l.prototype.setFade=function(){var t,o=this;o.$slides.each(function(i,e){t=o.slideWidth*i*-1,!0===o.options.rtl?d(e).css({position:"relative",right:t,top:0,zIndex:o.options.zIndex-2,opacity:0}):d(e).css({position:"relative",left:t,top:0,zIndex:o.options.zIndex-2,opacity:0})}),o.$slides.eq(o.currentSlide).css({zIndex:o.options.zIndex-1,opacity:1})},l.prototype.setHeight=function(){var i,e=this;1===e.options.slidesToShow&&!0===e.options.adaptiveHeight&&!1===e.options.vertical&&(i=e.$slides.eq(e.currentSlide).outerHeight(!0),e.$list.css("height",i))},l.prototype.setOption=l.prototype.slickSetOption=function(){var i,e,t,o,s,n=this,l=!1;if("object"===d.type(arguments[0])?(t=arguments[0],l=arguments[1],s="multiple"):"string"===d.type(arguments[0])&&(o=arguments[1],l=arguments[2],"responsive"===(t=arguments[0])&&"array"===d.type(arguments[1])?s="responsive":void 0!==arguments[1]&&(s="single")),"single"===s)n.options[t]=o;else if("multiple"===s)d.each(t,function(i,e){n.options[i]=e});else if("responsive"===s)for(e in o)if("array"!==d.type(n.options.responsive))n.options.responsive=[o[e]];else{for(i=n.options.responsive.length-1;0<=i;)n.options.responsive[i].breakpoint===o[e].breakpoint&&n.options.responsive.splice(i,1),i--;n.options.responsive.push(o[e])}l&&(n.unload(),n.reinit())},l.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},l.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},l.prototype.setSlideClasses=function(i){var e,t,o,s,n=this,l=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true").attr("aria-label",function(){return d(this).attr("aria-label").replace(" (centered)","")});n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode?(o=n.options.slidesToShow%2==0?1:0,s=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(s<=i&&i<=n.slideCount-1-s?n.$slides.slice(i-s+o,i+s+1).addClass("slick-active").removeAttr("aria-hidden"):(e=n.options.slidesToShow+i,l.slice(e-s+1+o,e+s+2).addClass("slick-active").removeAttr("aria-hidden")),0===i?l.eq(n.options.slidesToShow+n.slideCount+1).addClass("slick-center").attr("aria-label",function(){return d(this).attr("aria-label")+" (centered)"}):i===n.slideCount-1&&l.eq(n.options.slidesToShow).addClass("slick-center").attr("aria-label",function(){return d(this).attr("aria-label")+" (centered)"})),n.$slides.eq(i).addClass("slick-center").attr("aria-label",function(){return d(this).attr("aria-label")+" (centered)"})):0<=i&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").removeAttr("aria-hidden"):l.length<=n.options.slidesToShow?l.addClass("slick-active").removeAttr("aria-hidden"):(t=n.slideCount%n.options.slidesToShow,e=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?l.slice(e-(n.options.slidesToShow-t),e+t).addClass("slick-active").removeAttr("aria-hidden"):l.slice(e,e+n.options.slidesToShow).addClass("slick-active").removeAttr("aria-hidden")),"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},l.prototype.setupInfinite=function(){var i,e,t,o=this;if(!0===o.options.fade&&(o.options.centerMode=!1),!0===o.options.infinite&&!1===o.options.fade&&(e=null,o.slideCount>o.options.slidesToShow)){for(t=!0===o.options.centerMode?o.options.slidesToShow+1:o.options.slidesToShow,i=o.slideCount;i>o.slideCount-t;--i)e=i-1,d(o.$slides[e]).clone(!0).attr("id","").attr("data-slick-index",e-o.slideCount).prependTo(o.$slideTrack).addClass("slick-cloned");for(i=0;i<t+o.slideCount;i+=1)e=i,d(o.$slides[e]).clone(!0).attr("id","").attr("data-slick-index",e+o.slideCount).appendTo(o.$slideTrack).addClass("slick-cloned");o.$slideTrack.find(".slick-cloned").find("[id]").each(function(){d(this).attr("id","")})}},l.prototype.interrupt=function(i){i||this.autoPlay(),this.interrupted=i},l.prototype.selectHandler=function(i){var e=d(i.target).is(".slick-slide")?d(i.target):d(i.target).parents(".slick-slide"),t=(t=parseInt(e.attr("data-slick-index")))||0;this.slideCount<=this.options.slidesToShow?this.slideHandler(t,!1,!0):this.slideHandler(t)},l.prototype.slideHandler=function(i,e,t){var o,s,n,l,r,a,d=this;if(e=e||!1,!(!0===d.animating&&!0===d.options.waitForAnimate||!0===d.options.fade&&d.currentSlide===i))if(!1===e&&d.asNavFor(i),o=i,r=d.getLeft(o),l=d.getLeft(d.currentSlide),d.currentLeft=null===d.swipeLeft?l:d.swipeLeft,!1===d.options.infinite&&!1===d.options.centerMode&&(i<0||i>d.getDotCount()*d.options.slidesToScroll))!1===d.options.fade&&(o=d.currentSlide,!0!==t&&d.slideCount>d.options.slidesToShow?d.animateSlide(l,function(){d.postSlide(o)}):d.postSlide(o));else if(!1===d.options.infinite&&!0===d.options.centerMode&&(i<0||i>d.slideCount-d.options.slidesToScroll))!1===d.options.fade&&(o=d.currentSlide,!0!==t&&d.slideCount>d.options.slidesToShow?d.animateSlide(l,function(){d.postSlide(o)}):d.postSlide(o));else{if(d.options.autoplay&&clearInterval(d.autoPlayTimer),s=o<0?d.slideCount%d.options.slidesToScroll!=0?d.slideCount-d.slideCount%d.options.slidesToScroll:d.slideCount+o:o>=d.slideCount?d.slideCount%d.options.slidesToScroll!=0?0:o-d.slideCount:o,d.animating=!0,d.$slider.trigger("beforeChange",[d,d.currentSlide,s]),n=d.currentSlide,d.currentSlide=s,d.setSlideClasses(d.currentSlide),d.options.asNavFor&&(a=(a=d.getNavTarget()).slick("getSlick")).slideCount<=a.options.slidesToShow&&a.setSlideClasses(d.currentSlide),d.updateDots(),d.updateArrows(),!0===d.options.fade)return!0!==t?(d.fadeSlideOut(n),d.fadeSlide(s,function(){d.postSlide(s)})):d.postSlide(s),void d.animateHeight();!0!==t&&d.slideCount>d.options.slidesToShow?d.animateSlide(r,function(){d.postSlide(s)}):d.postSlide(s)}},l.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},l.prototype.swipeDirection=function(){var i=this,e=i.touchObject.startX-i.touchObject.curX,t=i.touchObject.startY-i.touchObject.curY,o=Math.atan2(t,e),s=Math.round(180*o/Math.PI);return s<0&&(s=360-Math.abs(s)),s<=45&&0<=s||s<=360&&315<=s?!1===i.options.rtl?"left":"right":135<=s&&s<=225?!1===i.options.rtl?"right":"left":!0===i.options.verticalSwiping?35<=s&&s<=135?"down":"up":"vertical"},l.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1;if(o.interrupted=!1,o.shouldClick=!(10<o.touchObject.swipeLength),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},l.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},l.prototype.swipeMove=function(i){var e,t,o,s,n,l=this,r=void 0!==i.originalEvent?i.originalEvent.touches:null;return!(!l.dragging||l.scrolling||r&&1!==r.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==r?r[0].pageX:i.clientX,l.touchObject.curY=void 0!==r?r[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),n=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&4<n?!(l.scrolling=!0):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=n),t=l.swipeDirection(),void 0!==i.originalEvent&&4<l.touchObject.swipeLength&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,(l.touchObject.edgeHit=!1)===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},l.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return!(t.touchObject={});void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},l.prototype.unfilterSlides=l.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},l.prototype.unload=function(){var i=this;d(".slick-cloned",i.$slider).remove(),i.$dots&&i.$dots.remove(),i.$prevArrow&&i.htmlExpr.test(i.options.prevArrow)&&i.$prevArrow.remove(),i.$nextArrow&&i.htmlExpr.test(i.options.nextArrow)&&i.$nextArrow.remove(),i.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},l.prototype.unslick=function(i){this.$slider.trigger("unslick",[this,i]),this.destroy()},l.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2);!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").prop("disabled",!1),i.$nextArrow.removeClass("slick-disabled").prop("disabled",!1),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").prop("disabled",!0),i.$nextArrow.removeClass("slick-disabled").prop("disabled",!1)):(i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode||i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode)&&(i.$nextArrow.addClass("slick-disabled").prop("disabled",!0),i.$prevArrow.removeClass("slick-disabled").prop("disabled",!1)))},l.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").find("button").removeAttr("aria-current").end().end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active").find("button").attr("aria-current",!0).end().end())},l.prototype.updateSlideVisibility=function(){this.$slideTrack.find(".slick-slide").attr("aria-hidden","true").find("a, input, button, select").attr("tabindex","-1"),this.$slideTrack.find(".slick-active").removeAttr("aria-hidden").find("a, input, button, select").removeAttr("tabindex")},l.prototype.visibility=function(){this.options.autoplay&&(document[this.hidden]?this.interrupted=!0:this.interrupted=!1)},d.fn.slick=function(){for(var i,e=this,t=arguments[0],o=Array.prototype.slice.call(arguments,1),s=e.length,n=0;n<s;n++)if("object"==typeof t||void 0===t?e[n].slick=new l(e[n],t):i=e[n].slick[t].apply(e[n].slick,o),void 0!==i)return i;return e}});

/*!
	Modaal - accessible modals - v0.4.4
	by Humaan, for all humans.
	http://humaan.com
 */
	!function(a){function t(a){var t={},o=!1;a.attr("data-modaal-type")&&(o=!0,t.type=a.attr("data-modaal-type")),a.attr("data-modaal-content-source")&&(o=!0,t.content_source=a.attr("data-modaal-content-source")),a.attr("data-modaal-animation")&&(o=!0,t.animation=a.attr("data-modaal-animation")),a.attr("data-modaal-animation-speed")&&(o=!0,t.animation_speed=a.attr("data-modaal-animation-speed")),a.attr("data-modaal-after-callback-delay")&&(o=!0,t.after_callback_delay=a.attr("data-modaal-after-callback-delay")),a.attr("data-modaal-is-locked")&&(o=!0,t.is_locked="true"===a.attr("data-modaal-is-locked")),a.attr("data-modaal-hide-close")&&(o=!0,t.hide_close="true"===a.attr("data-modaal-hide-close")),a.attr("data-modaal-background")&&(o=!0,t.background=a.attr("data-modaal-background")),a.attr("data-modaal-overlay-opacity")&&(o=!0,t.overlay_opacity=a.attr("data-modaal-overlay-opacity")),a.attr("data-modaal-overlay-close")&&(o=!0,t.overlay_close="false"!==a.attr("data-modaal-overlay-close")),a.attr("data-modaal-accessible-title")&&(o=!0,t.accessible_title=a.attr("data-modaal-accessible-title")),a.attr("data-modaal-start-open")&&(o=!0,t.start_open="true"===a.attr("data-modaal-start-open")),a.attr("data-modaal-fullscreen")&&(o=!0,t.fullscreen="true"===a.attr("data-modaal-fullscreen")),a.attr("data-modaal-custom-class")&&(o=!0,t.custom_class=a.attr("data-modaal-custom-class")),a.attr("data-modaal-close-text")&&(o=!0,t.close_text=a.attr("data-modaal-close-text")),a.attr("data-modaal-close-aria-label")&&(o=!0,t.close_aria_label=a.attr("data-modaal-close-aria-label")),a.attr("data-modaal-background-scroll")&&(o=!0,t.background_scroll="true"===a.attr("data-modaal-background-scroll")),a.attr("data-modaal-width")&&(o=!0,t.width=parseInt(a.attr("data-modaal-width"))),a.attr("data-modaal-height")&&(o=!0,t.height=parseInt(a.attr("data-modaal-height"))),a.attr("data-modaal-confirm-button-text")&&(o=!0,t.confirm_button_text=a.attr("data-modaal-confirm-button-text")),a.attr("data-modaal-confirm-cancel-button-text")&&(o=!0,t.confirm_cancel_button_text=a.attr("data-modaal-confirm-cancel-button-text")),a.attr("data-modaal-confirm-title")&&(o=!0,t.confirm_title=a.attr("data-modaal-confirm-title")),a.attr("data-modaal-confirm-content")&&(o=!0,t.confirm_content=a.attr("data-modaal-confirm-content")),a.attr("data-modaal-gallery-active-class")&&(o=!0,t.gallery_active_class=a.attr("data-modaal-gallery-active-class")),a.attr("data-modaal-loading-content")&&(o=!0,t.loading_content=a.attr("data-modaal-loading-content")),a.attr("data-modaal-loading-class")&&(o=!0,t.loading_class=a.attr("data-modaal-loading-class")),a.attr("data-modaal-ajax-error-class")&&(o=!0,t.ajax_error_class=a.attr("data-modaal-ajax-error-class")),a.attr("data-modaal-instagram-id")&&(o=!0,t.instagram_id=a.attr("data-modaal-instagram-id")),o&&a.modaal(t);}var o={init:function(t,o){var e=this;if(e.dom=a("body"),e.$elem=a(o),e.options=a.extend({},a.fn.modaal.options,e.$elem.data(),t),e.xhr=null,e.scope={is_open:!1,id:"modaal_"+(new Date).getTime()+Math.random().toString(16).substring(2),source:e.options.content_source?e.options.content_source:e.$elem.attr("href")},e.$elem.attr("data-modaal-scope",e.scope.id),e.private_options={active_class:"is_active"},e.lastFocus=null,e.options.is_locked||"confirm"==e.options.type||e.options.hide_close?e.scope.close_btn="":e.scope.close_btn='<button type="button" class="modaal-close" id="modaal-close" aria-label="'+e.options.close_aria_label+'"><span>'+e.options.close_text+"</span></button>","none"===e.options.animation&&(e.options.animation_speed=0,e.options.after_callback_delay=0),a(o).on("click.Modaal",function(a){a.preventDefault(),e.create_modaal(e,a);}),!0===e.options.outer_controls){var i="outer";}else {var i="inner";}e.scope.prev_btn='<button type="button" class="modaal-gallery-control modaal-gallery-prev modaal-gallery-prev-'+i+'" id="modaal-gallery-prev" aria-label="Previous image (use left arrow to change)"><span>Previous Image</span></button>',e.scope.next_btn='<button type="button" class="modaal-gallery-control modaal-gallery-next modaal-gallery-next-'+i+'" id="modaal-gallery-next" aria-label="Next image (use right arrow to change)"><span>Next Image</span></button>',!0===e.options.start_open&&e.create_modaal(e);},create_modaal:function(a,t){var o,a=this;if(a.lastFocus=a.$elem,!1!==a.options.should_open&&("function"!=typeof a.options.should_open||!1!==a.options.should_open())){switch(a.options.before_open.call(a,t),a.options.type){case"inline":a.create_basic();break;case"ajax":o=a.options.source(a.$elem,a.scope.source),a.fetch_ajax(o);break;case"confirm":a.options.is_locked=!0,a.create_confirm();break;case"image":a.create_image();break;case"iframe":o=a.options.source(a.$elem,a.scope.source),a.create_iframe(o);break;case"video":a.create_video(a.scope.source);break;case"instagram":a.create_instagram();}a.watch_events();}},watch_events:function(){var t=this;t.dom.off("click.Modaal keyup.Modaal keydown.Modaal"),t.dom.on("keydown.Modaal",function(o){var e=o.keyCode,i=o.target;9==e&&t.scope.is_open&&(a.contains(document.getElementById(t.scope.id),i)||a("#"+t.scope.id).find('*[tabindex="0"]').focus());}),t.dom.on("keyup.Modaal",function(o){var e=o.keyCode,i=o.target;return o.shiftKey&&9==o.keyCode&&t.scope.is_open&&(a.contains(document.getElementById(t.scope.id),i)||a("#"+t.scope.id).find(".modaal-close").focus()),!t.options.is_locked&&27==e&&t.scope.is_open?!a(document.activeElement).is("input:not(:checkbox):not(:radio)")&&void t.modaal_close():"image"==t.options.type?(37==e&&t.scope.is_open&&!a("#"+t.scope.id+" .modaal-gallery-prev").hasClass("is_hidden")&&t.gallery_update("prev"),void(39==e&&t.scope.is_open&&!a("#"+t.scope.id+" .modaal-gallery-next").hasClass("is_hidden")&&t.gallery_update("next"))):void 0;}),t.dom.on("click.Modaal",function(o){var e=a(o.target);if(!t.options.is_locked&&(t.options.overlay_close&&e.is(".modaal-inner-wrapper")||e.is(".modaal-close")||e.closest(".modaal-close").length)){return void t.modaal_close();}if(e.is(".modaal-confirm-btn")){return e.is(".modaal-ok")&&t.options.confirm_callback.call(t,t.lastFocus),e.is(".modaal-cancel")&&t.options.confirm_cancel_callback.call(t,t.lastFocus),void t.modaal_close();}if(e.is(".modaal-gallery-control")){if(e.hasClass("is_hidden")){return;}return e.is(".modaal-gallery-prev")&&t.gallery_update("prev"),void(e.is(".modaal-gallery-next")&&t.gallery_update("next"));}});},build_modal:function(t){var o=this,e="";"instagram"==o.options.type&&(e=" modaal-instagram");var i,l="video"==o.options.type?"modaal-video-wrap":"modaal-content";switch(o.options.animation){case"fade":i=" modaal-start_fade";break;case"slide-down":i=" modaal-start_slidedown";break;default:i=" modaal-start_none";}var n="";o.options.fullscreen&&(n=" modaal-fullscreen"),""===o.options.custom_class&&void 0===o.options.custom_class||(o.options.custom_class=" "+o.options.custom_class);var s="";o.options.width&&o.options.height&&"number"==typeof o.options.width&&"number"==typeof o.options.height?s=' style="max-width:'+o.options.width+"px;height:"+o.options.height+'px;overflow:auto;"':o.options.width&&"number"==typeof o.options.width?s=' style="max-width:'+o.options.width+'px;"':o.options.height&&"number"==typeof o.options.height&&(s=' style="height:'+o.options.height+'px;overflow:auto;"'),("image"==o.options.type||"video"==o.options.type||"instagram"==o.options.type||o.options.fullscreen)&&(s="");var d="";o.is_touch()&&(d=' style="cursor:pointer;"');var r='<div class="modaal-wrapper modaal-'+o.options.type+i+e+n+o.options.custom_class+'" id="'+o.scope.id+'"><div class="modaal-outer-wrapper"><div class="modaal-inner-wrapper"'+d+">";"video"!=o.options.type&&(r+='<div class="modaal-container"'+s+">"),r+='<div class="'+l+' modaal-focus" aria-hidden="false" aria-label="'+o.options.accessible_title+" - "+o.options.close_aria_label+'" role="dialog">',"inline"==o.options.type?r+='<div class="modaal-content-container" role="document"></div>':r+=t,r+="</div>"+o.scope.close_btn,"video"!=o.options.type&&(r+="</div>"),r+="</div>","image"==o.options.type&&!0===o.options.outer_controls&&(r+=o.scope.prev_btn+o.scope.next_btn),r+="</div></div>",a("#"+o.scope.id+"_overlay").length<1&&o.dom.append(r),"inline"==o.options.type&&t.appendTo("#"+o.scope.id+" .modaal-content-container"),o.modaal_overlay("show");},create_basic:function(){var t=this,o=a(t.scope.source),e="";o.length?(e=o.contents().detach(),o.empty()):e="Content could not be loaded. Please check the source and try again.",t.build_modal(e);},create_instagram:function(){var t=this,o=t.options.instagram_id,e="",i="Instagram photo couldn't be loaded, please check the embed code and try again.";if(t.build_modal('<div class="modaal-content-container'+(""!=t.options.loading_class?" "+t.options.loading_class:"")+'">'+t.options.loading_content+"</div>"),""!=o&&null!==o&&void 0!==o){var l="https://api.instagram.com/oembed?url=http://instagr.am/p/"+o+"/";a.ajax({url:l,dataType:"jsonp",cache:!1,success:function(o){t.dom.append('<div id="temp-ig" style="width:0;height:0;overflow:hidden;">'+o.html+"</div>"),t.dom.attr("data-igloaded")?window.instgrm.Embeds.process():t.dom.attr("data-igloaded","true");var e="#"+t.scope.id+" .modaal-content-container";a(e).length>0&&setTimeout(function(){a("#temp-ig").contents().clone().appendTo(e),a("#temp-ig").remove();},1e3);},error:function(){e=i;var o=a("#"+t.scope.id+" .modaal-content-container");o.length>0&&(o.removeClass(t.options.loading_class).addClass(t.options.ajax_error_class),o.html(e));}});}else {e=i;}return!1;},fetch_ajax:function(t){var o=this;null==o.options.accessible_title&&(o.options.accessible_title="Dialog Window"),null!==o.xhr&&(o.xhr.abort(),o.xhr=null),o.build_modal('<div class="modaal-content-container'+(""!=o.options.loading_class?" "+o.options.loading_class:"")+'">'+o.options.loading_content+"</div>"),o.xhr=a.ajax(t,{success:function(t){var e=a("#"+o.scope.id).find(".modaal-content-container");e.length>0&&(e.removeClass(o.options.loading_class),e.html(t),o.options.ajax_success.call(o,e));},error:function(t){if("abort"!=t.statusText){var e=a("#"+o.scope.id+" .modaal-content-container");e.length>0&&(e.removeClass(o.options.loading_class).addClass(o.options.ajax_error_class),e.html("Content could not be loaded. Please check the source and try again."));}}});},create_confirm:function(){var a,t=this;a='<div class="modaal-content-container"><h1 id="modaal-title">'+t.options.confirm_title+'</h1><div class="modaal-confirm-content">'+t.options.confirm_content+'</div><div class="modaal-confirm-wrap"><button type="button" class="modaal-confirm-btn modaal-ok" aria-label="Confirm">'+t.options.confirm_button_text+'</button><button type="button" class="modaal-confirm-btn modaal-cancel" aria-label="Cancel">'+t.options.confirm_cancel_button_text+"</button></div></div></div>",t.build_modal(a);},create_image:function(){var t,o,e=this,i="";if(e.$elem.is("[data-group]")||e.$elem.is("[rel]")){var l=e.$elem.is("[data-group]"),n=l?e.$elem.attr("data-group"):e.$elem.attr("rel"),s=a(l?'[data-group="'+n+'"]':'[rel="'+n+'"]');s.removeAttr("data-gallery-active","is_active"),e.$elem.attr("data-gallery-active","is_active"),o=s.length-1;var d=[];i='<div class="modaal-gallery-item-wrap">',s.each(function(t,o){var e="",i="",l="",n=!1,s=!1,r=o.getAttribute("data-modaal-desc"),c=o.getAttribute("data-gallery-active");a(o).attr("data-modaal-content-source")?e=a(o).attr("data-modaal-content-source"):a(o).attr("href")?e=a(o).attr("href"):a(o).attr("src")?e=a(o).attr("src"):(e="trigger requires href or data-modaal-content-source attribute",s=!0),""!=r&&null!==r&&void 0!==r?(i=r,l='<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image '+(t+1)+" - </span>"+r.replace(/</g,"&lt;").replace(/>/g,"&gt;")+"</div>"):l='<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image '+(t+1)+"</span></div>",c&&(n=!0);var m={url:e,alt:i,rawdesc:r,desc:l,active:n,src_error:s};d.push(m);});for(var r=0;r<d.length;r++){var c="",m=d[r].rawdesc?"Image: "+d[r].rawdesc:"Image "+r+" no description";d[r].active&&(c=" "+e.private_options.active_class);var p=d[r].src_error?d[r].url:'<img src="'+d[r].url+'" alt=" " style="width:100%">';i+='<div class="modaal-gallery-item gallery-item-'+r+c+'" aria-label="'+m+'">'+p+d[r].desc+"</div>";}i+="</div>",1!=e.options.outer_controls&&(i+=e.scope.prev_btn+e.scope.next_btn);}else{var u,_=!1;e.$elem.attr("data-modaal-content-source")?u=e.$elem.attr("data-modaal-content-source"):e.$elem.attr("href")?u=e.$elem.attr("href"):e.$elem.attr("src")?u=e.$elem.attr("src"):(u="trigger requires href or data-modaal-content-source attribute",_=!0);var v="",f="",m="";e.$elem.attr("data-modaal-desc")?(m=e.$elem.attr("data-modaal-desc"),v=e.$elem.attr("data-modaal-desc"),f='<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image - </span>'+v.replace(/</g,"&lt;").replace(/>/g,"&gt;")+"</div>"):m="Image with no description";var p=_?u:'<img src="'+u+'" alt=" " style="width:100%">';i='<div class="modaal-gallery-item is_active" aria-label="'+m+'">'+p+f+"</div>";}t=i,e.build_modal(t),a(".modaal-gallery-item.is_active").is(".gallery-item-0")&&a(".modaal-gallery-prev").hide(),a(".modaal-gallery-item.is_active").is(".gallery-item-"+o)&&a(".modaal-gallery-next").hide();},gallery_update:function(t){var o=this,e=a("#"+o.scope.id),i=e.find(".modaal-gallery-item"),l=i.length-1;if(0==l){return!1;}var n=e.find(".modaal-gallery-prev"),s=e.find(".modaal-gallery-next"),d=0,r=0,c=e.find(".modaal-gallery-item."+o.private_options.active_class),m="next"==t?c.next(".modaal-gallery-item"):c.prev(".modaal-gallery-item");return o.options.before_image_change.call(o,c,m),("prev"!=t||!e.find(".gallery-item-0").hasClass("is_active"))&&(("next"!=t||!e.find(".gallery-item-"+l).hasClass("is_active"))&&void c.stop().animate({opacity:0},250,function(){m.addClass("is_next").css({position:"absolute",display:"block",opacity:0});var t=a(document).width(),i=t>1140?280:50;d=e.find(".modaal-gallery-item.is_next").width(),r=e.find(".modaal-gallery-item.is_next").height();var p=e.find(".modaal-gallery-item.is_next img").prop("naturalWidth"),u=e.find(".modaal-gallery-item.is_next img").prop("naturalHeight");p>t-i?(d=t-i,e.find(".modaal-gallery-item.is_next").css({width:d}),e.find(".modaal-gallery-item.is_next img").css({width:d}),r=e.find(".modaal-gallery-item.is_next").find("img").height()):(d=p,r=u),e.find(".modaal-gallery-item-wrap").stop().animate({width:d,height:r},250,function(){c.removeClass(o.private_options.active_class+" "+o.options.gallery_active_class).removeAttr("style"),c.find("img").removeAttr("style"),m.addClass(o.private_options.active_class+" "+o.options.gallery_active_class).removeClass("is_next").css("position",""),m.stop().animate({opacity:1},250,function(){a(this).removeAttr("style").css({width:"100%"}),a(this).find("img").css("width","100%"),e.find(".modaal-gallery-item-wrap").removeAttr("style"),o.options.after_image_change.call(o,m);}),e.find(".modaal-gallery-item").removeAttr("tabindex"),e.find(".modaal-gallery-item."+o.private_options.active_class).attr("tabindex","0").focus(),e.find(".modaal-gallery-item."+o.private_options.active_class).is(".gallery-item-0")?n.stop().animate({opacity:0},150,function(){a(this).hide();}):n.stop().css({display:"block",opacity:n.css("opacity")}).animate({opacity:1},150),e.find(".modaal-gallery-item."+o.private_options.active_class).is(".gallery-item-"+l)?s.stop().animate({opacity:0},150,function(){a(this).hide();}):s.stop().css({display:"block",opacity:n.css("opacity")}).animate({opacity:1},150);});}));},create_video:function(a){var t,o=this;t='<iframe src="'+a+'" class="modaal-video-frame" frameborder="0" allowfullscreen></iframe>',o.build_modal('<div class="modaal-video-container">'+t+"</div>");},create_iframe:function(a){var t,o=this;t=null!==o.options.width||void 0!==o.options.width||null!==o.options.height||void 0!==o.options.height?'<iframe src="'+a+'" class="modaal-iframe-elem" frameborder="0" allowfullscreen></iframe>':'<div class="modaal-content-container">Please specify a width and height for your iframe</div>',o.build_modal(t);},modaal_open:function(){var t=this,o=a("#"+t.scope.id),e=t.options.animation;"none"===e&&(o.removeClass("modaal-start_none"),t.options.after_open.call(t,o)),"fade"===e&&o.removeClass("modaal-start_fade"),"slide-down"===e&&o.removeClass("modaal-start_slide_down");var i=o;a(".modaal-wrapper *[tabindex=0]").removeAttr("tabindex"),i="image"==t.options.type?a("#"+t.scope.id).find(".modaal-gallery-item."+t.private_options.active_class):o.find(".modaal-iframe-elem").length?o.find(".modaal-iframe-elem"):o.find(".modaal-video-wrap").length?o.find(".modaal-video-wrap"):o.find(".modaal-focus"),i.attr("tabindex","0").focus(),"none"!==e&&setTimeout(function(){t.options.after_open.call(t,o);},t.options.after_callback_delay);},modaal_close:function(){var t=this,o=a("#"+t.scope.id);t.options.before_close.call(t,o),null!==t.xhr&&(t.xhr.abort(),t.xhr=null),"none"===t.options.animation&&o.addClass("modaal-start_none"),"fade"===t.options.animation&&o.addClass("modaal-start_fade"),"slide-down"===t.options.animation&&o.addClass("modaal-start_slide_down"),setTimeout(function(){"inline"==t.options.type&&a("#"+t.scope.id+" .modaal-content-container").contents().detach().appendTo(t.scope.source),o.remove(),t.options.after_close.call(t),t.scope.is_open=!1;},t.options.after_callback_delay),t.modaal_overlay("hide"),null!=t.lastFocus&&t.lastFocus.focus();},modaal_overlay:function(t){var o=this;"show"==t?(o.scope.is_open=!0,o.options.background_scroll||o.dom.addClass("modaal-noscroll"),a("#"+o.scope.id+"_overlay").length<1&&o.dom.append('<div class="modaal-overlay" id="'+o.scope.id+'_overlay"></div>'),a("#"+o.scope.id+"_overlay").css("background",o.options.background).stop().animate({opacity:o.options.overlay_opacity},o.options.animation_speed,function(){o.modaal_open();})):"hide"==t&&a("#"+o.scope.id+"_overlay").stop().animate({opacity:0},o.options.animation_speed,function(){a(this).remove(),o.dom.removeClass("modaal-noscroll");});},is_touch:function(){return"ontouchstart"in window||navigator.maxTouchPoints;}},e=[];a.fn.modaal=function(t){return this.each(function(i){var l=a(this).data("modaal");if(l){if("string"==typeof t){switch(t){case"open":l.create_modaal(l);break;case"close":l.modaal_close();}}}else{var n=Object.create(o);n.init(t,this),a.data(this,"modaal",n),e.push({element:a(this).attr("class"),options:t});}});},a.fn.modaal.options={type:"inline",content_source:null,animation:"fade",animation_speed:300,after_callback_delay:350,is_locked:!1,hide_close:!1,background:"#000",overlay_opacity:"0.8",overlay_close:!0,accessible_title:"Dialog Window",start_open:!1,fullscreen:!1,custom_class:"",background_scroll:!1,should_open:!0,close_text:"Close",close_aria_label:"Close (Press escape to close)",width:null,height:null,before_open:function(){},after_open:function(){},before_close:function(){},after_close:function(){},source:function(a,t){return t;},confirm_button_text:"Confirm",confirm_cancel_button_text:"Cancel",confirm_title:"Confirm Title",confirm_content:"<p>This is the default confirm dialog content. Replace me through the options</p>",confirm_callback:function(){},confirm_cancel_callback:function(){},gallery_active_class:"gallery_active_item",outer_controls:!1,before_image_change:function(a,t){},after_image_change:function(a){},loading_content:'<div class="modaal-loading-spinner"><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div>',loading_class:"is_loading",ajax_error_class:"modaal-error",ajax_success:function(){},instagram_id:null},a(function(){var o=a(".modaal");o.length&&o.each(function(){t(a(this));});var i=new MutationObserver(function(o){o.forEach(function(o){if(o.addedNodes&&o.addedNodes.length>0){[].some.call(o.addedNodes,function(o){var i=a(o);(i.is("a")||i.is("button"))&&(i.hasClass("modaal")?t(i):e.forEach(function(t){if(t.element==i.attr("class")){return a(i).modaal(t.options),!1;}}));});}});}),l={subtree:!0,attributes:!0,childList:!0,characterData:!0};setTimeout(function(){i.observe(document.body,l);},500);});}(jQuery,window,document);


/**
* what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
* @version v4.2.0
* @link https://github.com/ten1seven/what-input
* @license MIT
*/
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define("whatInput",[],t):"object"==typeof exports?exports.whatInput=t():e.whatInput=t();}(this,function(){return function(e){function t(o){if(n[o]){return n[o].exports;}var i=n[o]={exports:{},id:o,loaded:!1};return e[o].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports;}var n={};return t.m=e,t.c=n,t.p="",t(0);}([function(e,t){"use strict";e.exports=function(){var e="initial",t=null,n=document.documentElement,o=["input","select","textarea"],i=[],r=[16,17,18,91,93],u=[9],d={keydown:"keyboard",mousedown:"mouse",mousemove:"mouse",MSPointerDown:"pointer",MSPointerMove:"pointer",pointerdown:"pointer",pointermove:"pointer",touchstart:"touch"},s=[],a=!1,c=!1,p={x:null,y:null},f={2:"touch",3:"touch",4:"mouse"},v=!1;try{var m=Object.defineProperty({},"passive",{get:function(){v=!0;}});window.addEventListener("test",null,m);}catch(e){}var w=function(){window.PointerEvent?(n.addEventListener("pointerdown",l),n.addEventListener("pointermove",y)):window.MSPointerEvent?(n.addEventListener("MSPointerDown",l),n.addEventListener("MSPointerMove",y)):(n.addEventListener("mousedown",l),n.addEventListener("mousemove",y),"ontouchstart"in window&&(n.addEventListener("touchstart",x),n.addEventListener("touchend",x))),n.addEventListener(b(),y,!!v&&{passive:!0}),n.addEventListener("keydown",l);},l=function(n){if(!a){var i=n.which,s=d[n.type];if("pointer"===s&&(s=L(n)),e!==s||t!==s){var c=document.activeElement,p=!1;(c&&c.nodeName&&-1===o.indexOf(c.nodeName.toLowerCase())||-1!==u.indexOf(i))&&(p=!0),("touch"===s||"mouse"===s||"keyboard"===s&&i&&p&&-1===r.indexOf(i))&&(e=t=s,h());}}},h=function(){n.setAttribute("data-whatinput",e),n.setAttribute("data-whatintent",e),-1===s.indexOf(e)&&(s.push(e),n.className+=" whatinput-types-"+e),E("input");},y=function(e){if(p.x!==e.screenX||p.y!==e.screenY?(c=!1,p.x=e.screenX,p.y=e.screenY):c=!0,!a&&!c){var o=d[e.type];"pointer"===o&&(o=L(e)),t!==o&&(t=o,n.setAttribute("data-whatintent",t),E("intent"));}},x=function(e){"touchstart"===e.type?(a=!1,l(e)):a=!0;},E=function(e){for(var n=0,o=i.length;n<o;n++){i[n].type===e&&i[n].function.call(void 0,t);}},L=function(e){return"number"==typeof e.pointerType?f[e.pointerType]:"pen"===e.pointerType?"touch":e.pointerType;},b=function(){return"onwheel"in document.createElement("div")?"wheel":void 0!==document.onmousewheel?"mousewheel":"DOMMouseScroll";};return"addEventListener"in window&&Array.prototype.indexOf&&function(){d[b()]="mouse",w(),h();}(),{ask:function(n){return"loose"===n?t:e;},types:function(){return s;},ignoreKeys:function(e){r=e;},onChange:function(e,t){i.push({function:e,type:t});}};}();}]);});

	
// This is used for UNC's wait times
var buildWaitTimes = (function ($) {
	'use strict';

	var ClockWise = function (settings) {
		var options = {
			hospitalName: 'Hospital Name',
			hospitalID: null,
			appendTo: '.ClockWiseWaitTimeWrapper'
		};
		if (settings) {
			$.each(settings, function (key, obj) {
				options[key] = obj;
			});
		}

		options.hospitalID = options.hospitalID.split(', ');
		options.hospitalName = options.hospitalName.split(', ');
		if (options.hospitalID !== null && options.appendTo !== null) {
			//Build Clockwise API CALL per their specifications
			//https://github.com/LightshedHealth/Website-Widget-API

			$.each(options.hospitalID, function (i, elm) {

				//Build API Call for each hospital ID given.
				var script = '<script src="https://www.clockwisemd.com/hospitals/' + options.hospitalID[i] + '/current_wait.html"></script>';
				$('head').first().append(script);
			});

			//Uses discovery function from clockwise api.js script to return wait time.
			$('body').on('clockwise_waits_loaded', function (e, id) {
				var waitTime = $(Clockwise.Waits[id]).html(),
					timeString = '';
				if (waitTime.indexOf('-') > -1) {
					waitTime = waitTime.split('-');

					//check to see if the first wait time is over 59 minutes. Is so we need to convert to hours
					if (waitTime[0] > 59) {
						timeString = waitTimeFormat(waitTime[0]);
					} else {
						timeString = waitTimeMinutes(Math.floor(waitTime[0] / 60), waitTime[0] % 60);
					}
					waitTime[1] = waitTime[1].substr(0, waitTime[1].indexOf(' '));
					//check to see if the second wait time is over 59 minutes
					if (waitTime[1] > 59) {
						//for the second time in the range, we need to add a '-' to separate the times
						timeString += " - " + waitTimeFormat(waitTime[1]);
					} else {
						timeString += " - " + waitTimeMinutes(Math.floor(waitTime[1] / 60), waitTime[1] % 60);
					}
				} else {
					timeString = waitTime;
				}

				// Loop through the hospital Names and match them to their respective ID
				// Then output the html to the clockwiseWrapper element.
				if (parseInt(options.hospitalID) === id) {
					var markup = '';
					// unc pn wait times
					if (window.location.href.indexOf("/pn/") > -1) {
						if ($('div.clockwiseWaitTime').length === 0) {
							$('<div class="clockwiseWaitTime Center ' + id + '"> ' +
								'<p><strong>' + options.hospitalName + '</strong> <br/>' +
								'' + timeString + '</p> <p><a class="Button" href="//www.clockwisemd.com/hospitals/' + id + '/appointments/new">Reserve my spot now</a></p></div>').appendTo(options.appendTo);
						} else {
							markup = '<div class="clockwiseWaitTime ' + id + '"> ' +
								'<p><strong>' + options.hospitalName + '</strong> <br/>' +
								'' + timeString + '</p> <p><a class="Button" href="//www.clockwisemd.com/hospitals/' + id + '/appointments/new">Reserve my spot now</a></p></div>';
							$(markup).appendTo(options.appendTo);
						}
					} 
					// all other wait times
					else {
						markup = '<div class="clockwiseWaitTime ' + id + '"> ' +
							'<p class="ERWTRow">' +
							'<span class="Name"><a href="#">' + options.hospitalName + '</a></span> ' +
							'<span class="Time" style="display: inline-block;">' + timeString + '</span> <a class="ButtonGold" href="//www.clockwisemd.com/hospitals/' + id + '/appointments/new">Reserve my spot now</a></p></div>';
						$(markup).appendTo(options.appendTo);
					}

					/*Location Profile Wait Time Changes */
					// Change Button on Location Profile if in Location CTA custom content field
					if ($('.CustomProfile #LocationCTA .clockwiseWaitTime a.ButtonGold').length){
						$('.CustomProfile #LocationCTA .clockwiseWaitTime a.ButtonGold').removeClass('ButtonGold').addClass('Button');
					}

					// Move Custom Wait Time Label if in Location CTA custom content field
					if ($('.CustomProfile #LocationCTA .ClockWiseWaitTimeWrapper .WaitTimeLabel').length){
						$('.CustomProfile #LocationCTA .ClockWiseWaitTimeWrapper .WaitTimeLabel').prependTo('.CustomProfile #LocationCTA .ClockWiseWaitTimeWrapper .clockwiseWaitTime .ERWTRow');
					}
				
				}
			});
		}
		// Give console error if certain requirements were not met to run plugin.
		else {
			console.error('No Hospital ID or Page Element to place after.');
		}
	};
	return {
		//Global Name: local name
		ClockWise: ClockWise
	};
})(jQuery, VitalSite);

// This is used for Pardees wait times
function formatWaitTimes() {
	$('.ERWTRow .Time').each(function(i, elem) {
		var waitTime = $(elem).html();
		var timeString = '';

		if (waitTime.indexOf('-') > -1) {
			waitTime = waitTime.split(' - ');

			//check to see if the first wait time is over 59 minutes. Is so we need to convert to hours
			if (waitTime[0] > 59) {
				timeString = waitTimeFormat(waitTime[0]);
			} else {
				timeString = waitTimeMinutes(Math.floor(waitTime[0] / 60), waitTime[0] % 60);
			}
			//check to see if the second wait time is over 59 minutes
			if (waitTime[1] > 59) {
				//for the second time in the range, we need to add a '-' to separate the times
				timeString += " - " + waitTimeFormat(waitTime[1]);
			} else {
				timeString += " - " + waitTimeMinutes(Math.floor(waitTime[1] / 60), waitTime[1] % 60);
			}
		} else {
			timeString = waitTime;
		}
		$(elem).html(timeString);
	});
}

//bind to resize
$(window).on('resize', function() {
	'use strict';
	if ($('input').is(':focus')) {
		//do nothing
	} else {
		WindowSize();
		moveElements();

		equalHeight.clear($('.BackgroundPanel .cmspanel'));
		//make columns equal heigh
		equalHeight.equalHeight($('#RowOne.BackgroundPanel .cmspanel'));
		equalHeight.equalHeight($('#RowTwo.BackgroundPanel .cmspanel'));
		equalHeight.equalHeight($('#RowThree.BackgroundPanel .cmspanel'));
		equalHeight.equalHeight($('#RowFour.BackgroundPanel .cmspanel'));
		equalHeight.equalHeight($('#RowFive.BackgroundPanel .cmspanel'));
		equalHeight.equalHeight($('#RowSix.BackgroundPanel .cmspanel'));
		equalHeight.equalHeight($('#RowSeven.BackgroundPanel .cmspanel'));
	}
});

//bind to Orientation Change
$(window).on("orientationchange", function () {
	'use strict';
	if ($('input').is(':focus')) {
		//do nothing
	} else {
		WindowSize();
		moveElements();
		equalHeight.clear($('.BackgroundPanel .cmspanel'));
		//make columns equal height
		equalHeight.equalHeight($('#RowOne.BackgroundPanel .cmspanel'));
		equalHeight.equalHeight($('#RowTwo.BackgroundPanel .cmspanel'));
		equalHeight.equalHeight($('#RowThree.BackgroundPanel .cmspanel'));
		equalHeight.equalHeight($('#RowFour.BackgroundPanel .cmspanel'));
		equalHeight.equalHeight($('#RowFive.BackgroundPanel .cmspanel'));
		equalHeight.equalHeight($('#RowSix.BackgroundPanel .cmspanel'));
		equalHeight.equalHeight($('#RowSeven.BackgroundPanel .cmspanel'));
		if($('#wait-time-map-iframe').length) {
			$('#wait-time-map-iframe').attr("src", $('#wait-time-map-iframe').attr("src"));
		}
	}
});

$(function () {
	// Forces the first "Tab" to be open on mobile sizes when the tabsToAccordions funciton is used
	$('#FormsAndDocuments .TabContainer').data('accordionClasses', 'StartOn1');
});

// Quality Reports
$(function () {
	// update hex colors with client colors
	var BarColor = ('56a0d3,fbaf41,005595,5c5f66,2376a1,56a0d3,fbaf41,005595,5c5f66,2376a1').split(',');
	$('table.Chart').each(function (k, v) {
		var rows = $(v).find('tr'),
			labelwidth = 0,
			barmax = 0,
			percentage = false;
		if ($(this).find('td:contains("%")').length() > 0) {
			percentage = true;
		}

		rows.each(function (i) {
			var className = 'data';

			var label = $(this).find('td').eq(0),
				data = $(this).find('td').eq(1),

				/* If the value does not start with a number or a decimal, assign the value to zero; remove all non digits or non decimals from the value */
				value = $.trim(data.text().replace(/^[^1-9|\.]+/g, '0').replace(/[^0-9|\.]+/g, '')),
				bgcolor = $(this).data('color') || '#' + BarColor[i],
				wdth = '';
			label.addClass('Label').wrapInner('<span/>');
			if (percentage) { wdth = 'width:' + value + '%;' }
			if (value.indexOf('0') === 0 || value === 0) {
				// if the value starts with a zero or equals zero
				className = "smallData";
				bgcolor = "none";
				wdth = "";
			}
			else if (value < 0) { className = "smallData"; }
			data.html('<span class="' + className + '">' + data.text() + '</span><div class="Bar" title="' + value + '%" style="background-color: ' + bgcolor + ';' + wdth + '">' + value + '</div>');
		});

		if (!percentage) {
			rows.find('.Bar').each(function () {
				if (parseInt($(this).text()) > barmax) { barmax = parseInt($(this).text()); }
			});
			var ratio = barmax / 100;
			rows.find('.Bar').each(function () {
				$(this).width(parseInt($(this).text() / ratio) + '%').attr('title', $(this).text());
			});

		}
		rows.find('.Label span').addClass('Sizer').each(function () {
			if ($(this).outerWidth() > labelwidth) { labelwidth = $(this).outerWidth(); }
			$(this).removeClass('Sizer');
		});
		rows.find('.Label').width(labelwidth);
	});
});

function isEmpty(el) {
	return !$.trim(el.html());
}

function breakout_of_frame() {
	if (top.location != location) {
		top.location.href = document.location.href;
	}
}

function AddChildrensClass() {
	if ($('#SectionLogoWrap img.ChildrensLogo, #Logo img.ChildrensLogo').length > 0) {
		$('body').addClass('Childrens');
		$('head').append('<link href="/css/templates/childrens.css" rel="stylesheet" />');
	}
}

function addEmailLink() {
	var clientDomainName = '[clientDomainName]',
		clientSiteName = '[clientSiteName]',
		currentPageUrl = document.location,
		currentPageTitle = $.trim($('title').text()),
		emailSubject = clientDomainName + ': ' + currentPageTitle,
		emailHref = 'mailto:?subject=' + escape(emailSubject) + '&body=I thought you would be interested in a page on the ' + escape(clientSiteName) + ' Web site: ' + escape(currentPageTitle) + ' - ' + escape(currentPageUrl);
	$('#Col2 #Content').before('<p class="EmailLink"><a href="' + emailHref + '">Email this page</a></p><p class="PrintLink"><a href="javascript:;" onclick="print();">Print Page</a></p>');
}

function waitTimeFormat(elem) {
	'use strict';
	//divide the total time by 60 to see if we have hours
	var hours = Math.floor(elem / 60),
		//minutes is determined by the remainder of mins left over from the hours
		minutes = elem % 60;
	//if more than one hour add an "s"
	return hours > 1 ? hours + " hours" + waitTimeMinutes(Math.floor(hours), minutes) : hours + " hour" + waitTimeMinutes(Math.floor(hours), minutes);
}

function waitTimeMinutes(hrs, min) {
	'use strict';
	//if hours > 0 add a comma to the string to show hours, mins
	var minutes = hrs > 0 ? ", " + min + " mins" : min + " mins";
	if (min === 1) {
		//add a comma if hours and make 'mins' singular
		minutes = hrs > 0 ? ", " + min + " min" : min + "min";
	} else if (hrs > 0 && min === 0) {
		//if we have hours and 0 mins, don't show '0 mins'
		minutes = "";
	}
	return minutes;
}

function WindowSize() {
	var w = Math.max($(window).width(), window.innerWidth);
	var type = 'Default';
	if ($('body.UNCPN').length) {
		if (w <= 572) {
			type = 'Mobile';
		}
		else if (w <= 774) {
			type = 'Tablet';
		}
		else if (w <= 1024) {
			type = 'TabletTwo';
		}
		else if (w <= 1207) {
			type = 'TabletBig';
		}
		else {
			type = 'Default';
		}
	} else {

		if (w <= 572) {
			type = 'Mobile';
		}
		else if (w <= 774) {
			type = 'Tablet';
		}
		else if (w <= 1207) {
			type = 'TabletBig';
		}
		else {
			type = 'Default';
		}
	}

	// change the css file of the tag with id="stl" and rel="stylesheet"
	$('body').removeClass('Default').removeClass('TabletBig').removeClass('TabletTwo').removeClass('Tablet').removeClass('Mobile').addClass(type);

}

function logoName() {
	if ($('#Logo .cmsPanelContent .RexLogo').length > 0) {
		$('body').addClass("Rex");
	}
	if ($('#Logo .cmsPanelContent .ChathamLogo').length > 0) {
		$('body').addClass("Chatham");
	}
	if ($('#Logo .cmsPanelContent .MedicalCenterLogo').length > 0) {
		$('body').addClass("MedicalCenter");
	}
}

function moveElements() {
	$("#Slot6 .cmspanel").css('height', 'auto');

	if ($('body').hasClass('Mobile') || $('body').hasClass('Tablet')) {
		equalHeight.clear($('#CampaignTwo #RowOne .CampaignRow > .cmspanel h3'));
		equalHeight.clear($('#CampaignTwo #RowOne .CampaignRow > .cmspanel'));
	} else {
		equalHeight.equalHeight($('#CampaignTwo #RowOne .CampaignRow > .cmspanel h3'));
		equalHeight.equalHeight($('#CampaignTwo #RowOne .CampaignRow > .cmspanel'));
	}

	/* Search */
	$('.System.Mobile #Search').appendTo('.Mobile #Header .Payloads .Search');
	$('.System.Tablet #Search').appendTo('.Tablet #Header .Payloads .Search');
	$('.System.TabletBig #Search').appendTo('.TabletBig #GrayBar .Triggers .Link');
	$('.System.Default #Search').appendTo('.Default #GrayBar .Triggers .Link');

	/* GrayBar MyChart Panel */
	$('.Mobile #GrayBar .MyChart .Column3').insertAfter('.Mobile #GrayBar .MyChart .Column1');
	$('.Tablet #GrayBar .MyChart .Column3').insertAfter('.Tablet #GrayBar .MyChart .Column1');
	$('.TabletBig #GrayBar .MyChart .Column3').insertAfter('.TabletBig #GrayBar .MyChart .Column2');
	$('.Default #GrayBar .MyChart .Column3').insertAfter('.Default #GrayBar .MyChart .Column2');

	/* GrayBar Care Link Panel */
	$('.Mobile #GrayBar .CareLink .Column3').insertAfter('.Mobile #GrayBar .CareLink .Column1');
	$('.Tablet #GrayBar .CareLink .Column3').insertAfter('.Tablet #GrayBar .CareLink .Column1');
	$('.TabletBig #GrayBar .CareLink .Column3').insertAfter('.TabletBig #GrayBar .CareLink .Column2');
	$('.Default #GrayBar .CareLink .Column3').insertAfter('.Default #GrayBar .CareLink .Column2');

	/* Main Nav */
	if ($('body.uncpn').length) {
		//Do nothing
	} else {
		$('.Mobile #MainNav').appendTo('.CustomToggles .Menu .NavContent');
		$('.Tablet #MainNav').appendTo('.CustomToggles .Menu .NavContent');
		$('.TabletBig .CustomToggles .Menu .NavContent #MainNav').appendTo('#MainNavWrapper');
		$('.Default .CustomToggles .Menu .NavContent #MainNav').appendTo('#MainNavWrapper');
	}

	/* Columns */
	// #436545 - Prevent map reloading on resize.
	$('#Columns div').each(function() {
		if($('#ColumnOne').index() < $('#ColumnTwo').index()) {
			$('.Mobile #ColumnTwo').insertBefore('#ColumnOne');
			$('.Tablet #ColumnTwo').insertBefore('#ColumnOne');
		}
	});
	$('.Mobile #ColumnThree').insertAfter('#ColumnOne');
	$('.Tablet #ColumnThree').insertAfter('#ColumnOne');
	$('.TabletBig #ColumnOne').insertBefore('#ColumnTwo');
	$('.TabletBig #ColumnThree').appendTo('#ColumnOne');
	$('.Default #ColumnThree').insertAfter('#ColumnTwo');
	$('.Default #ColumnOne').insertBefore('#ColumnTwo');

	/* Columns */
	$('#SystemHome.Mobile #ColumnTwo').insertAfter('#ColumnOne');
	$('#SystemHome.Mobile #ColumnThree').insertAfter('#ColumnTwo');
	$('#SystemHome.Tablet #ColumnTwo').insertAfter('#ColumnOne');
	$('#SystemHome.Tablet #ColumnThree').insertBefore('#ColumnTwo');
	$('#SystemHome.TabletBig #ColumnOne').insertBefore('#ColumnTwo');
	$('#SystemHome.TabletBig #ColumnThree').insertBefore('#ColumnTwo');
	$('#SystemHome.Default #ColumnThree').insertAfter('#ColumnTwo');
	$('#SystemHome.Default #ColumnOne').insertBefore('#ColumnTwo');

	/* Prox Nav */
	if ($('body.uncpn').length) {
		$('.Mobile #ProximityNavWrap').insertAfter('.Mobile #alert-wrap');
		$('.Tablet #ProximityNavWrap').insertAfter('.Tablet #alert-wrap');
	} else {
		$('.Mobile #ProximityNavWrap').insertAfter('.Mobile #BreadcrumbWrap');
		$('.Tablet #ProximityNavWrap').insertAfter('.Tablet #BreadcrumbWrap');
	}
	$('.TabletBig #ProximityNavWrap').insertBefore('.TabletBig #LeftColumnPanels');
	$('.Default #ProximityNavWrap').insertBefore('.Default #LeftColumnPanels');

	/* Section Logo */
	$('.Mobile #SectionLogoWrap').insertAfter('.Mobile #BreadcrumbWrap');
	$('.Tablet #SectionLogoWrap').insertAfter('.Tablet #BreadcrumbWrap');
	$('.TabletBig #SectionLogoWrap').insertBefore('.TabletBig #ProximityNavWrap');
	$('.Default #SectionLogoWrap').insertBefore('.Default #ProximityNavWrap');

	/* Call To Action */
	if ($('body.uncpn').length) {
		if ($('#PracticeLocation').length) {
			$('.Default #CallToAction, .TabletBig #CallToAction').appendTo('.cmspage .Row:first');
			if ($('.Mobile .cmsPageContent .MainContent .Move-CTA-Here, .Tablet .cmsPageContent .MainContent .Move-CTA-Here, .TabletTwo .cmsPageContent .MainContent .Move-CTA-Here').length) {
				$('#CallToAction').appendTo('.cmsPageContent .MainContent .Move-CTA-Here');
			} else if ($('.Mobile .cmsPageContent .MainContent .cmsPageContent > h1, .Tablet .cmsPageContent .MainContent .cmsPageContent > h1, .TabletTwo .cmsPageContent .MainContent .cmsPageContent > h1').length) {
				$('#CallToAction').insertAfter('.cmsPageContent .MainContent > h1');
			}
		} else {
			if ($('.TabletBig .cmsPageContent > h1,.Tablet .cmsPageContent > h1,.Mobile .cmsPageContent > h1').length > 0) {
				$('.TabletBig #ColumnThree #CallToAction').insertAfter('.cmsPageContent > h1:eq(0)');
				$('.Tablet #ColumnThree #CallToAction').insertAfter('.cmsPageContent > h1:eq(0)');
				$('.Mobile #ColumnThree #CallToAction').insertAfter('.cmsPageContent > h1:eq(0)');
			} else {
				$('.TabletBig #ColumnThree #CallToAction').prependTo('.cmsPageContent');
				$('.Tablet #ColumnThree #CallToAction').prependTo('.cmsPageContent');
				$('.Mobile #ColumnThree #CallToAction').prependTo('.cmsPageContent');
			}
			$('.Default .cmsPageContent #CallToAction').prependTo('#ColumnThree');
		}
	} else {
		if ($('.TabletBig .cmsPageContent > h1,.Tablet .cmsPageContent > h1,.Mobile .cmsPageContent > h1').length > 0) {
			$('.TabletBig #ColumnThree #CallToAction').insertAfter('.cmsPageContent > h1:eq(0)');
			$('.Tablet #ColumnThree #CallToAction').insertAfter('.cmsPageContent > h1:eq(0)');
			$('.Mobile #ColumnThree #CallToAction').insertAfter('.cmsPageContent > h1:eq(0)');
		} else {
			$('.TabletBig #ColumnThree #CallToAction').prependTo('.cmsPageContent');
			$('.Tablet #ColumnThree #CallToAction').prependTo('.cmsPageContent');
			$('.Mobile #ColumnThree #CallToAction').prependTo('.cmsPageContent');
		}
		$('.Default .cmsPageContent #CallToAction').prependTo('#ColumnThree');
	}
	// ShoppingCart
	if ($('.Mobile .Payloads #ShoppingCartLink, .Tablet .Payloads #ShoppingCartLink').length > 0) {
		$('#Header .CustomToggles .Triggers .Cart').removeClass('DisplayNone');
	}
	if ($('.TabletBig .Payloads #ShoppingCartLink, .Default .Payloads #ShoppingCartLink').length > 0) {
		$('#Header .CustomToggles .Triggers .Cart').addClass('DisplayNone');
	}
	if ($('.Default .Payloads .Cart').has('style')) {
		$('.Default .Payloads .Cart').removeAttr('style');
	}
	if ($('.TabletBig .Payloads .Cart').has('style')) {
		$('.TabletBig .Payloads .Cart').removeAttr('style');
	}

	// Homepage Smart Panel More links
	$('.Default #Slot6 .ContentLeft p.MoreLink a').appendTo('.Default #Slot6 .ContentLeft h3');
	$('.TabletBig #Slot6 .ContentLeft p.MoreLink a').appendTo('.TabletBig #Slot6 .ContentLeft h3');
	$('.Tablet #Slot6 .ContentLeft p.MoreLink a').appendTo('.Tablet #Slot6 .ContentLeft h3');
	$('.Mobile #Slot6 .ContentLeft p.MoreLink a').insertAfter('.Mobile #Slot6 .ContentLeft ul.SPList');

	$('.Default #Slot6 .ContentRight p.MoreLink a').appendTo('.Default #Slot6 .ContentRight h3');
	$('.TabletBig #Slot6 .ContentRight p.MoreLink a').appendTo('.TabletBig #Slot6 .ContentRight h3');
	$('.Tablet #Slot6 .ContentRight p.MoreLink a').appendTo('.Tablet #Slot6 .ContentRight h3');
	$('.Mobile #Slot6 .ContentRight p.MoreLink a').insertAfter('.Mobile #Slot6 .ContentRight ul.SPList');

	/* Campaign Landing page */
	$('.Campaign.Tablet #MainNav, .Campaign.Mobile #MainNav').appendTo('#MobileMenu');
	$('.Campaign.TabletBig #MainNav, .Campaign.Default #MainNav').appendTo('nav .ContentWrap');

	if ($('.Campaign .Left a.CTAButton')) {
		$('.Campaign .Left a.CTAButton').parent().parent().addClass('LeftCTA');
	}

	$('.Campaign.Tablet .Left a.CTAButton, .Campaign.Mobile .Left a.CTAButton').each(function () {
		$(this).appendTo($(this).parent().parent().find('.Right'));
	});

	$('.Campaign.TabletBig .LeftCTA a.CTAButton, .Campaign.Default .LeftCTA a.CTAButton').each(function () {
		if ($(this).parent().find('.Left .Map')) {
			$(this).insertBefore($(this).parents('.LeftCTA').find('.Left .Map'));
		} else {
			$(this).appendTo($(this).parents('.LeftCTA').find('.Left'));
		}
	});

	/* CampaignTwo Landing Page */
	if ($('#CampaignTwo .cmsPageContent .Move-CTA-Here').length) {
		$('#CampaignTwo.Mobile #CallToAction').appendTo('#CampaignTwo .cmsPageContent .Move-CTA-Here');
		$('#CampaignTwo.Tablet #CallToAction').appendTo('#CampaignTwo .cmsPageContent .Move-CTA-Here');
	} else {
		$('#CampaignTwo.Mobile #CallToAction').insertAfter('.cmsPageContent > h1:first');
		$('#CampaignTwo.Tablet #CallToAction').insertAfter('.cmsPageContent > h1:first');
	}
	$('#CampaignTwo.TabletBig #CallToAction').prependTo('.cmsPageContent');
	$('#CampaignTwo.Default #CallToAction').prependTo('.cmsPageContent');

	// Move Get Care Now Button on XSmall screen size
	$('body.Tablet, body.Mobile').each(function() {
		$('#GrayBar .IsButton').prependTo('#GrayBar .Triggers');
	});
	$('body.Default, body.TabletBig, body.TabletTwo').each(function() {
		$('#GrayBar .IsButton').appendTo('#GrayBar .Triggers');
	});
}

function FormatNavs() {
	//format the way the text in the main nav breaks in default view
	$('#MainNav ul li span').each(function (i, el) {
		if ($(el).html() == "Caring for North Carolina") {
			$(el).html("Caring for <span class='Break'>North Carolina</span>");
		}
		if ($(el).html() == "Health System Entities") {
			$(el).html("Health System <span class='Break'>Entities</span>");
		}
		if ($(el).html() == "Find a Doctor") {
			$(el).html("Find a <span class='Break'>Doctor</span>");
		}
		if ($(el).html() == "Research &amp; Innovation") {
			$(el).html("Research <span class='Break'>&amp; Innovation</span>");
		}
		if ($(el).html() == "Quality &amp; Awards") {
			$(el).html("Quality <span class='Break'>&amp; Awards</span>");
		}
		//UNCPN Navigation
		if ($(el).html() == "Practices &amp; Locations") {
			$(el).html("Practices <span class='Break'>&amp; Locations</span>");
		}
	});
}

function breadArrow() {
	if ($('body.Mobile #Breadcrumbs p').length) {
		if ($('#Breadcrumbs p').html().length) {
			$('#Breadcrumbs p img').html(
				$('#Breadcrumbs p img').replaceWith('&gt;')
			);
		}
	}
	if ($('body.Tablet #Breadcrumbs p').length) {
		if ($('#Breadcrumbs p').html().length) {
			if ($('.System').length) {
				$('#Breadcrumbs p').html(
					$('#Breadcrumbs p').html().replace(/&gt;/g, '<img src="/imgs/system-interior/breadcrumb-separator.png" alt="" />')
				);
			} else {
				$('#Breadcrumbs p').html(
					$('#Breadcrumbs p').html().replace(/&gt;/g, '<img src="/imgs/shared/bread.gif" alt="" />')
				);
			}
		}
	}
	if ($('body.TabletBig #Breadcrumbs p').length) {
		if ($('#Breadcrumbs p').html().length) {
			if ($('.System').length) {
				$('#Breadcrumbs p').html(
					$('#Breadcrumbs p').html().replace(/&gt;/g, '<img src="/imgs/system-interior/breadcrumb-separator.png" alt="" />')
				);
			} else {
				$('#Breadcrumbs p').html(
					$('#Breadcrumbs p').html().replace(/&gt;/g, '<img src="/imgs/shared/bread.gif" alt="" />')
				);
			}
		}
	}
	if ($('body.Default #Breadcrumbs p').length) {
		if ($('#Breadcrumbs p').html().length) {
			if ($('.System').length) {
				$('#Breadcrumbs p').html(
					$('#Breadcrumbs p').html().replace(/&gt;/g, '<img src="/imgs/system-interior/breadcrumb-separator.png" alt="" />')
				);
			}
			else if ($('.ThreeColumns').length) {
				// do nothing
			}
			else {
				$('#Breadcrumbs p').html(
					$('#Breadcrumbs p').html().replace(/&gt;/g, '<img src="/imgs/shared/bread.gif" alt="" />')
				);
			}
		}
	}
}

function truncateBoxDay() {
	$('.BoxDay span:contains("Sunday")').text("Sun");
	$('.BoxDay span:contains("Monday")').text("Mon");
	$('.BoxDay span:contains("Tuesday")').text("Tue");
	$('.BoxDay span:contains("Wednesday")').text("Wed");
	$('.BoxDay span:contains("Thursday")').text("Thur");
	$('.BoxDay span:contains("Friday")').text("Fri");
	$('.BoxDay span:contains("Saturday")').text("Sat");
}

function footerBullets() {
	if ($('.System').length) {
		$('#FooterLegal').removeClass('ClearFix');
		$('#FooterLegal').removeAttr('class');
	}
	var numFooterLinks = $('#FooterTop li').length;
	$('#FooterTop li').each(function (i) {
		if (i < numFooterLinks - 1) {
			if ($('.System').length) {
				$('<img src="/imgs/system-interior/footer-bullet-blue.gif" alt="" />').insertAfter(this);
			}
			else if ($('.uncpn').length) {
				//do nothing
			}
			else {
				$('<img src="/imgs/shared/icons/footer-bullet.gif" alt="" />').insertAfter(this);
			}
		}
	});
}

$(function () {
	$('#ServicesSearch .TabContainer').data('accordionClasses', 'StartOn1');
});

// Change Tabs into Accordions
function TabsToAccordions() {

	// do this for each tab container
	$('.TabContainer').each(function (k, TabContainer) {

		// new accordion container (jquery object)
		var NewAccordion = $('<div class="ResponsiveAccordion Accordion ' + $(this).data('accordionClasses') + '"></div>');

		// loop through all tabs in the current tab container
		$(this).find('.Tab').each(function (k, tab) {

			// create objects for the new trigger and payload
			var AccordionTrigger = $('<h3>' + $(tab).find(':header:first').text() + '</h3>'),
				AccordionPayload = $('<div class="TheTabContent">' + $(tab).html() + '</div>');

			// add trigger and empty payload to the accordion container
			AccordionTrigger.appendTo(NewAccordion);
			AccordionPayload.appendTo(NewAccordion);

			// when clicking on an accordion trigger, get the contents from the tab and put it in the payload... only if it's empty
			AccordionTrigger.mousedown(function (e) {
				if (AccordionPayload.is(':empty')) {
					var NewTabContents = $(tab).clone();

					// if there's a google map in the tab, then do some funky stuff
					if (NewTabContents.find('.MapContainer').length() > 0) {
						$(tab).find('#MapId').attr('id', 'MapIdOriginal');
						$(tab).find('.MapContainer').attr('class', 'MapContainerOriginal');
						NewTabContents.find('#MapId').remove();
						NewTabContents.find('.GoogleLocateOnMapLink').remove();
						setTimeout(function () { Geo_InitMap(); }, 1000);
					}

					// put tab contents in the payload
					NewTabContents.appendTo(AccordionPayload);

				}
			}); // end click event

		});
		NewAccordion.remove('script');
		$(TabContainer).after(NewAccordion);
		$('.TheTabContent .TabHeader').remove();
	});
	doAccordions();

	// if you addded a 'StartOn' class to make an accordion payload automatically visible, trigger it so it has content
	$('.ResponsiveAccordion[class*="StartOn"]').each(function () {
		$(this).find('.Trigger').eq(parseInt($(this).attr('class').split('StartOn')[1]) - 1).trigger('mousedown');
	});
}

function BasicSearch() {
	// This markup is added to the panel
	// Markup to look like this:
	//    <div class="basicSearch">
	//        <input class="theKeyword" name="keyword" type="text" />
	//        <input class="theSearchPage" type="hidden" value="/site-search" />
	//        <input class="thisInputText" type="hidden" value="i am looking for" />
	//        <input type="hidden" class="querystr" value="term" >
	//        <input type="hidden" class="sorting" value="0" >
	//        <input type="hidden" class="errorText" value="Please enter in your search criteria." >
	//        <input class="Button basicSearchButton" type="button" value="Search" />
	//    </div>
	// NOTE: querystr and sorting inputs are OPTIONAL - if they don't exist, they default to "keyword" and "7" respectively

	$('.basicSearch').each(function () {
		var $BS = $(this),
			defaultText = $BS.find('input.thisInputText').val(),
			$input = $BS.find('input.theKeyword'),
			searchPage = $.url.attr('protocol') + '://' + $.url.attr('host') + $BS.find('input.theSearchPage').val() + '?',
			querystr = $BS.find('input.querystr').val() || '',
			querystr = (querystr.length) ? querystr + '=' : 'keyword=',
			sorting = $BS.find('input.sorting').val() || '',
			sorting = sorting !== '0' ? (sorting.length ? 'sort=' + sorting + '&' : 'sort=7&') : '',
			errorText = $BS.find('input.errorText').val() || '',
			errorText = (errorText.length) ? errorText : 'Please enter in your search criteria.';
		if (defaultText.length) {
			$input.val(defaultText);
		}
		// keyboard input bindings
		$input
			.on('focus', function () {
				if ($(this).val() === defaultText) {
					$(this).val('');
				}
			})
			.on('blur', function () {
				if ($(this).val() === '') {
					$(this).val(defaultText);
				}
			})
			.on('keypress', function (e) {
				$BS.find('.error').slideUp().remove();
				if (e.keyCode === 13) {
					e.preventDefault(); // dont submit the ASP.Net form
					if (defaultText.length === 0) {
						defaultText = '';
					}
					var kword = $(this).val();
					if (kword.length && kword !== defaultText) {
						window.location = (searchPage + sorting + querystr + kword);
					} else {
						showBSError($input);
					}
				}
			});
		// clicking on the search button
		$BS.find('.basicSearchButton').on('click', function() {
			if (defaultText.length === 0) {
				defaultText = '';
			}
			var kword = $input.val();
			if (kword.length && kword !== defaultText) {
				window.location = (searchPage + sorting + querystr + kword);
			} else {
				showBSError($input);
			}
		});

		// show error message
		function showBSError(input) {
			if ($BS.find('.error').length() === 0) {
				input.before('<div style="color:red" class="error">' + errorText + '</div>');
			}
		}
	});
}

/* System Templates
------------------------------------------------------------------*/
// Get height of each panel on System Homepage
Array.max = function (array) {
	return Math.max.apply(Math, array);
};

function getPanelHeights() {
	var panelHeights = [];
	$('#SystemHome #Columns .cmspanel').each(function () {
		panelHeights.push($(this).height());
	});
	setPanelHeights(panelHeights);
}

function setPanelHeights(array) {
	$('#SystemHome #Columns .cmspanel').height(Array.max(array));
}

// Equal Height Script
var equalHeight = (function ($) {
	"use strict";

	// remove inline min height from the group
	function clear(group) {
		group.css('min-height', '');
	};

	// make group equal heights
	function equalHeight(group) {

		// reset height set by this script
		clear(group);

		// defining a variable that will keep track of the height of the tallest element
		var tallest = 0;

		// loop through elements, find the tallest outer height (includes padding)
		group.each(function () {

			// this is the outer height of the element (it doesn't round up or down to whole numbers)
			var thisHeight = this.getBoundingClientRect().bottom - this.getBoundingClientRect().top;

			if (thisHeight > tallest) {
				tallest = thisHeight;
			}
		});

		// loop through elements again, individually set their min-height so that their total height (including padding) = our tallest element
		group.each(function () {

			// if this has css box-sizing: border box, set the min-height equal to the tallest
			if (isBorderBox(this)) {

				group.css('min-height', Math.ceil(tallest));

			} else {

				// if an element has padding
				if ($(this).outerHeight() > $(this).height()) {

					// calulate how much border and padding is on the element
					var thisPadding = $(this).outerHeight() - $(this).height();

					// set the height of the element to the tallest, but leave room for the padding
					group.css('min-height', Math.ceil(tallest - thisPadding));

				} else {

					// if the element has no padding, simply set the height to our tallest
					group.css('min-height', Math.ceil(tallest));
				}
			}
		});
	};

	// check to see if the page is using box-sizing: border-box;
	function isBorderBox(elem) {
		return window.getComputedStyle(elem).boxSizing === "border-box";
	};

	return {
		equalHeight: equalHeight,
		outerHeight: equalHeight,
		clear: clear
	};

})(jQuery);

function CreateQualityReports() {
	$('.quality').each(function (index, element) {
		var el = $(element).find('.numberLarge');
		//build in the vertical graph based on the number provided
		$('<span class="unitWrapper"><span style="height:' + $(el).text() + '" class="unitContainer unitValue"></span></span>').insertAfter(el);
	});

	//open/close the tooltip
	$('.question, .tooltipClose').on('click', function (e) {
		var w = Math.min($(window).width(), window.innerWidth),
			el = $(this).parents('.qualityTop').siblings('.tooltipWrapper');

		if ($(el).hasClass('showTip')) {
			//the tooltip is opened and the icon was clicked on again. Close it.
			$(el).removeClass('showTip');
		} else {
			//make sure multiple tooltips aren't open at the same time
			removeTooltip();

			//get the coordinates from where the user clicked
			var top = ($(this).offset().top) - ($(this).parents('.quality').offset().top + $(this).height());
			var left = ($(this).offset().left) - ($(this).parents('.quality').offset().left);

			if (($(this).offset().left + $('.tooltipWrapper').outerWidth() + $(this).outerWidth() * 2) > w) {
				//there is not enough room to show the tooltip on the right side. Show it to the left
				left -= ($('.tooltipWrapper').outerWidth() - $(this).outerWidth());
				$(el).removeClass('tooltipWrapper').addClass('tooltipWrapperLeft');
			} else {
				//show the tooltip to the right of where you clicked. The default way.
				left += $(this).outerWidth() * 1.5;
			}
			$(el).css('top', top).css('left', left).toggleClass('showTip');

			//hide the tootip title area if there is no title
			if ($(el).find('.tooltipTitle').text().length === 0) {
				$(el).find('.tooltipTitle').hide();
			}
		}
	});
}

//Recipe HUB
function relatedTags() {
	"use strict";
	
	//$('.PagePublicationDate').wrap('<div class="ContentTop"></div>');
	//if ($('.FeaturedImgWrap').length > 0) {
	//	$('.ContentTop').insertAfter('.FeaturedImgWrap');
	//}
	var balanceAuthor = '',
	//	balanceContentType = '',
		hubDietaryTopic = '',
		hubRecipeIngredients = '',
		hubRecipeType = '',
		hubTopicUrl = '',
		url = window.location.href;

	if (url.indexOf('/rex-healthcare/rex-bariatrics-recipe-hub') > 0) {
		hubTopicUrl = "/rex-healthcare/rex-bariatrics-recipe-hub/#"
	}
	if (("taxonomy" in VitalSite) && VitalSite.taxonomy !== null) {
		var taxonomy = VitalSite.taxonomy;
		$(taxonomy).each(function (i, element) {
			/*if (element.FacetName === 'Balance Author') { //build out the balance author container once - only if authors exist
				$('.ContentTop').append("<p class='BalanceAuthor'><strong>View more content by this author: </strong><span></span></p>");
			}*/
			if ((element.FacetName === 'Dietary Requirements') || (element.FacetName === 'Recipe Type') && $('.RelatedRecipeHeader').length === 0) { //build out the balance tags header once - only if topic or serviceline content exists
				$('.HubTags').prepend("<h3 class='RelatedRecipeHeader'>Related Topics & Services</h3>");
			}
			$(element.Terms).each(function (j, elm) { //loop through all of the terms for the page
				//console.log(elm);
				/*if (element.FacetName === 'Balance Author') { //found 'Balance Author'
					balanceAuthor = (elm.Name);
					var balanceAuthorHash = (balanceAuthor.toString().replace(/\s+/g, '').replace(/[^a-zA-Z 0-9]+/g,''));
					$('.BalanceAuthor span').append("<a href='/balance/#" + balanceAuthorHash + "'>" + balanceAuthor + "</a>, ");
				}*/
				/*if (element.FacetName === 'Balance Content Type') {
					balanceContentType = (elm.Name);
					var balanceContentTypeHash = (balanceContentType.toString().replace(/\s+/g, '').replace(/,/g, ' ').replace(/[^a-zA-Z 0-9]+/g,''));
					$('.HubTags').append(
					"<a href='/balance/#" + balanceContentTypeHash + "'>" + balanceContentType + "</a>, ");
				}*/
				if (element.FacetName === 'Dietary Requirements') {
					hubDietaryTopic = (elm.Name);
					var hubDietaryTopicHash = (hubDietaryTopic.toString().replace(/\s+/g, '').replace(/[^a-zA-Z 0-9]+/g,''));
					$('.HubTags').append("<a href='" + hubTopicUrl + hubDietaryTopicHash + "'>" + hubDietaryTopic + "</a> ");
				}
				/*if (element.FacetName === 'Ingredients') {
					hubRecipeIngredients = (elm.Name);
					var hubRecipeIngredientsHash = (hubRecipeIngredients.toString().replace(/\s+/g, '').replace(/[^a-zA-Z 0-9]+/g,''));
					$('.HubTags').append("<a href='/rex-healthcare/rex-bariatrics-recipe-hub/#" + hubRecipeIngredientsHash + "'>" + hubRecipeIngredients + "</a> ");
				}*/
				if (element.FacetName === 'Recipe Type') {
					hubRecipeType = (elm.Name);
					var hubRecipeTypeHash = (hubRecipeType.toString().replace(/\s+/g, '').replace(/[^a-zA-Z 0-9]+/g, ''));
					$('.HubTags').append("<a href='" + hubTopicUrl + hubRecipeTypeHash + "'>" + hubRecipeType + "</a> ");
				}
			});
		});
	}
	//removing last comma from tag list
	var strVal = $.trim($('.HubTags').html());
	var lastChar = strVal.slice(-1);
	if (lastChar === ',') {
		strVal = strVal.slice(0, -1);
	}

	strVal = strVal.replace("<a href='" + hubTopicUrl + "NoTopic" + "</a> ", '');
	$(".HubTags").html(strVal);
	
	//removing last comma from author list
	var authorStrVal = $.trim($('.BalanceAuthor span').html());
	var authorLastChar = authorStrVal.slice(-1);
	if (authorLastChar === ',') {
		authorStrVal = authorStrVal.slice(0, -1);
	}
	$(".BalanceAuthor span").html(authorStrVal);
}
// Related panel for single filter Healthy Recipes
function relatedHealthyTags() {
	"use strict";
	
	var hubCategoryTopic = '',
		hubTopicUrl = '',
		url = window.location.href;

	if (url.indexOf('/rh/care-treatment/heart-vascular/north-carolina-heart-vascular-hospital/heart-healthy-recipes/') > 0) {
		hubTopicUrl = "/rh/care-treatment/heart-vascular/north-carolina-heart-vascular-hospital/heart-healthy-recipes/#"
	}
	if (("taxonomy" in VitalSite) && VitalSite.taxonomy !== null) {
		var taxonomy = VitalSite.taxonomy;
		$(taxonomy).each(function (i, element) {

			if ((element.FacetName === 'Healthy Recipe Categories') && $('.RelatedRecipeHeader').length === 0) { //build out the balance tags header once - only if topic or serviceline content exists
				$('.HubTags').prepend("<h3 class='RelatedRecipeHeader'>Related Topics & Services</h3>");
			}
			$(element.Terms).each(function (j, elm) { //loop through all of the terms for the page
				
				if (element.FacetName === 'Healthy Recipe Categories') {
					hubCategoryTopic = (elm.Name);
					var hubCategoryTopicHash = (hubCategoryTopic.toString().replace(/\s+/g, '').replace(/[^a-zA-Z 0-9]+/g,''));
					$('.HubTags').append("<a href='" + hubTopicUrl + hubCategoryTopicHash + "'>" + hubCategoryTopic + "</a> ");
				}
			});
		});
	}
	//removing last comma from tag list
	var strVal = $.trim($('.HubTags').html());
	var lastChar = strVal.slice(-1);
	if (lastChar === ',') {
		strVal = strVal.slice(0, -1);
	}
}


/* =========================================================================================================================*/
/* The following items before document.ready must remain functions to be called separately on the shared error-app template */
/* =========================================================================================================================*/

/* Gray Bar Navigation
----------------------------------------------------------------- */
function graybarNav(){	
	$('#GrayBar .Triggers ul li').appendTo('#GrayBar .Triggers');
	$('#GrayBar .Triggers .cmspanel').remove();
	$('#GrayBar .Triggers li:empty').remove();
	$('#GrayBar .Payloads li .cmspanel .BasicPanel .cmsPanelContent').closest('li').addClass('Dropdown');

	/* GrayBar Keyboard Accessibility Fix */

	$('#GrayBar ul.Triggers').wrap('<div class="Triggers ClearFix" />').contents().unwrap();

	// $('#GrayBar .Triggers li').each(function () {
	// 	var yourDiv = $(this);
	// 	var yourClasses = $(this).attr('class');
	// 	if (!$(yourDiv).hasClass('Link')) {
	// 		var yourSpan = $('<button class="Trigger ' + yourClasses + '" role="tab" aria-selected="false" tabindex="0" />');
	// 		yourDiv.before(yourSpan);
	// 		yourSpan.append(yourDiv.children());
	// 		yourDiv.remove();
	// 	} else {
	// 		var yourSpan = $('<div class="Trigger ' + yourClasses + '" />');
	// 		yourDiv.before(yourSpan);
	// 		yourSpan.append(yourDiv.children());
	// 		yourDiv.remove();
	// 	}
	// });

	$('#GrayBar .Triggers li').each(function () {
		var yourDiv = $(this);
		var yourClasses = $(this).attr('class');
		if (!$(yourDiv).hasClass('Link')) {
			var yourSpan = $('<button class="Trigger ' + yourClasses + '" role="tab" aria-selected="false" tabindex="0" />');
			yourDiv.before(yourSpan);
			yourSpan.append(yourDiv.children());
			yourDiv.remove();
		} else {
			var yourSpan = $('<div class="Trigger ' + yourClasses + '" role="link" aria-selected="false" />');
			yourDiv.before(yourSpan);
			yourSpan.append(yourDiv.children());
			yourDiv.remove();
		}
	});

	$('#GrayBar .Triggers').attr('role', 'tablist');

	$('#GrayBar .Payloads li').each(function () {
		$(this).attr('role', 'tabpanel').attr('aria-expanded', 'false').attr('aria-hidden', 'true');
	});

	// Move Get Care Now Button on XSmall screen size
	$('body.Tablet, body.Mobile').each(function() {
		$('#GrayBar .IsButton').prependTo('#GrayBar .Triggers');
	});
	$('body.Default, body.TabletBig, body.TabletTwo').each(function() {
		$('#GrayBar .IsButton').appendTo('#GrayBar .Triggers');
	});

}

function graybarTrigger(){
	$('#GrayBar').each(function () {
		// create variables to use for the triggers and payloads
		var $GB = $(this),
			$triggers = $GB.find('.Triggers>button.Trigger'),
			$payloads = $GB.find('.Payloads>li.Dropdown');

		// loop thru the triggers - using "i" as the counter, you can associate the tigger with the payload
		$triggers.each(function (i, trigger) {

			// clicking a trigger will slide up all payloads and will only slide down
			// if the associated payload wasn't the one you triggered
			$(trigger).on('click', function() {
				$triggers.removeClass('Active');
				if ($payloads.eq(i).is(':hidden')) {
					$payloads.slideUp();
					// slide down the associated payload
					// .slideDown(1000) is 1 second
					// .slideDown(1000, function(){ do.something })
					// do.something happens after the slideDown command is finished.
					// zIndexTop is a class to make sure that the one you
					// clicked on is always sliding over the others.
					$payloads.eq(i).addClass('zIndexTop').slideDown(300, function () {
						$(this).removeClass('zIndexTop');
						$triggers.eq(i).addClass('Active');
					});
				}
				else {
					$payloads.slideUp();
				}
				setTimeout(function () {
					//resetting nav offset if gray bar is changed.
					$navigation = $("#HeaderWrap");
					offsetnav = $navigation.offset();
				}, 500);
			});
		});
	});

	// Gray bar is being hidden in css because until the page loads it looks terrible
	// keep this line last in the doc ready to display the gray bar after everything is loaded - this keeps the page from "jumping" so much
	
	$('#GrayBarWrapper').show();
}

//slider functionality
function sliders() {

	$('.Slider').not('.slick-initialized').on('afterChange',function(){
		$('iframe').each(function(){ //on change slide = do action (pause iframe video)
			$(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
		});
	}).slick({
		adaptiveHeight: false,
		dots: true,
		arrows: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 8000,
		speed: 500,
		fade: true,
		cssEase: 'linear',
		responsive: [
			{
				breakpoint: 1207,
				settings: {
					dots: false,
					arrows: true
				}
			}
		]
	});
	// converting old flexslider to slick slider
	$('.slides').slick({
		adaptiveHeight: true,
		dots: true,
		arrows: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 8000,
		speed: 500,
		fade: true,
		cssEase: 'linear'
	});
	$('.PhotoSlider ul').not('.slick-initialized').slick({
		dots: false,
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1
	});
}

/* Mobile Navigation
   ----------------------------------------------------------------- */
function mobileNav() {	
	$('.CustomToggles').each(function () {
		// create variables to use for the triggers and payloads
		var $CT = $(this),
			$triggers = $CT.find('.Triggers>li'),
			$payloads = $CT.find('.Payloads>li');

		// loop thru the triggers - using "i" as the counter, you can associate the tigger with the payload
		$triggers.each(function (i, trigger) {

			// clicking a trigger will slide up all payloads and will only slide down
			// if the associated payload wasn't the one you triggered
			$(trigger).on('click', function() {
				$triggers.removeClass('Active');

				if ($payloads.eq(i).is(':hidden')) {
					//$payloads.slideUp();
					$payloads.removeClass('Active');
					// slide down the associated payload
					// .slideDown(1000) is 1 second
					// .slideDown(1000, function(){ do.something })
					// do.something happens after the slideDown command is finished.
					// zIndexTop is a class to make sure that the one you
					// clicked on is always sliding over the others.
					$payloads.eq(i).addClass('zIndexTop Active');
					$payloads.eq(i).removeClass('zIndexTop');
					$triggers.eq(i).addClass('Active');
				}
				else {
					//$payloads.slideUp();
					$payloads.removeClass('Active');
					$triggers.removeClass('Active');
				}
			});
		});
	});
}

function BackToTop() {
	'use strict';
	$('footer').not('#Blank footer').after('<div role="complementary" aria-label="Return to top" id="back-top"><a href="#">back to top of page <span></span></a></div>');
	$("#back-top").hide(); // hide #back-top first
	$(function() { // fade in #back-top
		$(window).on('scroll', function() {
			if ($(this).scrollTop() > 100) {
				$('#back-top').fadeIn();
			} else {
				$('#back-top').fadeOut();
			}
		});
		// scroll body to 0px on click
		$('#back-top a').on('click', function() {
			$('body,html').animate({
				scrollTop: 0
			}, 600);
			$('header').attr('tabindex','-1');
			$('header').focus(); // Set focus to top
			return false;
		});
	});
}


/* Breadcrumbs
----------------------------------------------------------------- */
function breadCrumbs(){	
	$('#Breadcrumbs').addClass('ClearFix');

	// Remove Breadcrumbs on root sections that are using an interior page as the homepage
	if ($('#Breadcrumbs').length) {
		var NumBreadLinks = $('#Breadcrumbs p a').length;
		if (NumBreadLinks === 0) {
			$('#Breadcrumbs p').remove();
		}
	}
}

/* MainNav
----------------------------------------------------------------- */
function mainNavFix(){	
	// Remove ClearFix from MainNav
	$('#MainNav h2').insertBefore('#MainNav');
	$('#MainNav').removeClass("ClearFix");
}

/*  Prox Nav Drop Down for Mobile
	----------------------------------------------------------------- */
function proximityMobileToggle(){	
	$("a#ProximityToggle").click(function () {
		$("#ProximityNavWrap1").slideToggle();
		$("#ProximityToggle").toggleClass("Open");
		return false;
	});
}

/* Call To Action Panel - Remove if Empty
---------------------------------------------------------------- */
function callToActionAdjust(){
	if ($('#CallToAction').length) {
		if ($('#CallToAction').html().trim().length <= 0) {
			$('#CallToAction').remove();
		}
	}
}

function hasSpecialty() {
	/*  Add class more specific class to doctor pop out specialties - LevelAcess
	----------------------------------------------------------------- */
	var title,
		eventNum = 1;
	$('#RightSider .Doctor').each(function () {
		title = $(this).find('h1').text().trim();
		if ($(this).find('.Specialty').length) {
			$(this).find('.Specialty').addClass('Specialty-' + title);
		} 
		eventNum++;
	});
}

/* ============================================================================================*/
/*End of Required Functions */
/* ============================================================================================*/

$(document).on('ready', function () {
	$('body').removeClass('NoScript');

	// initializing clicktocall DA before sliders() is run to fix focusable content being hidden issue
	var clickToCall = ClickToCall.Create();
	clickToCall.Setup();

	BasicSearch();
	WindowSize();
	moveElements();
	FormatNavs();
	if (!$('body').hasClass('uncpn')) {
		breadArrow();
	}
	footerBullets();
	logoName();
	truncateBoxDay();
	sliders();
	AddChildrensClass();
	bannerNoWrap();
	BackToTop();
	//getPanelHeights();

	//  DA initializers.
	let tabsAccordions = TabsAccordions.Create({
		Breakpoint: 1000,
		Animation: 400
	});
	tabsAccordions.Setup();

	// buildWaitTimes.ClockWise({
	//      hospitalName: 'Rex Express Care of Cary',
	//      hospitalID: '1387',
	//      appendTo: '#clockWiseWaitTimes'
	//   });
	// FAD open in new tab
	$('#DrSmartPanel li a').attr('target', '_blank');
	$('#DrResults .DrList li.Profile a').attr('target', '_blank');

	// ----------- TEMPLATE EXTRAS ------------------//
	//Adding body class for recipe interior page
	
	if ($('.Recipe').length) {
		$('body').addClass('RecipeInterior');
	};

		/*  Lightbox
	----------------------------------------------------------------- */
	// $('.inline').hover(function () {
	// 	var modalId = $(this).attr('href');
	// 	$(modalId).modaal('show');
	// });
	
	// $(".inline").modaal();

	$("a.Lightbox-for-image").modaal({ type: 'image' });
	$("a.Lightbox-for-video").modaal({ type: 'video' });
	$("a.Lightbox-for-iframe").modaal({ 
		type: 'iframe',
		width: 1000
	});

	// ----------- Doctor Smart Panels Ratings ------------------//

	/* var docNPIs = [];
	// Doctor Ratings for Smart Panels
	if ($('#DrResults').length > 0) {
		docNPIs = [];
		// drResultsData();
		smartPanelDrData();
	} else if ($('#DrSmartPanel').length > 0) {
		docNPIs = [];
		smartPanelDrData();
	}

	function smartPanelDrData() {
		var lastLength = docNPIs.length;
		var newCount = 0;

		$('#DrSmartPanel .DrList > li, #DrResults .DrList > li').each(function(index) {
			if (index >= lastLength) {
				var docNPI = $(this).find('.NpiNumber').text();
				docNPIs.push(docNPI);
				newCount ++;
			}
		});

		if (newCount > 0) {
			$.getProviderRatingsListByIds({
				providerIds: docNPIs.slice(lastLength, lastLength + newCount).toString()
			}, function (data)
			{
				// if doctor is not in NPI system, but has NPI number on SP
				if (Object.keys(data).length < docNPIs.length) {
					// loop over docNPIs and find missing result(s)
					docNPIs.forEach(spDoc => {
						if (!data.hasOwnProperty(spDoc)) {
							data[spDoc] = 'no value';
						}
					});
				}
				addRatingMarkup(data);
			});
		}

		function addRatingMarkup(data)  {

			for (var doc in data) {
				$('.NpiNumber:contains('+doc+')').closest('.DrList > li').each(function() {
					if (data[doc] !== undefined && data[doc].RatingCount >= 30) {
						var docName = $(this).find('dl > dt > a').text();
						var docUrl = $(this).find('a').attr('href');

						var ratingsHTML =
						'<div class="ProviderRatings" itemscope itemtype="https://schema.org/Physician"><a class="ProviderRatingsAnchor" href="' + docUrl + '">\
							<div class="docscores-badge-widget">\
								<div class="pied-badge" itemtype="https://schema.org/AggregateRating" itemscope="" itemprop="aggregateRating">\
									<span class="pied-badge-title Hide">Patient Rating</span>\
									<div class="star-container stars">\
										<span class="pied-badge-stars pull-left stars" style="width: '+parseFloat(data[doc].Rating)*20+'%"></span>\
									</div>\
									<div class="rating-container">\
										<meta itemprop="worstRating" content="1">\
										<span class="rating-value" itemprop="ratingValue">'+data[doc].Rating+'</span> out of <span itemprop="bestRating">5</span>\
										<span class="rating-count" itemprop="ratingCount">(' +data[doc].RatingCount+ ' Ratings)</span>\
									</div>\
								</div>\
							</div>\
						</a></div>';
						$(ratingsHTML).insertAfter($(this).find('dd.Specialties'));
					} else if (data[doc] !== undefined && data[doc].RatingCount <= 29) {
						var docFullUrl = $(this).find('a').attr('href');
						var docNum = "";
						if (docFullUrl !== undefined) {
							docNum = docFullUrl.split('/');
						}
						var noratingsHTML = '<div class="ProviderRatings">\
							<div class="Unavailable">\
								<a href="https://www.unchealth.org/about-us/learn-about-our-survey" target="_blank">Ratings Not Available</a>\
							</div>\
							</div>';
						$(noratingsHTML).insertAfter($(this).find('dd.Specialties'));
					} else if (data[doc] == 'no value') {
						var noratingsHTML = '<div class="ProviderRatings">\
							<div class="Unavailable">\
								<a href="https://www.unchealth.org/about-us/learn-about-our-survey" target="_blank">Ratings Not Available</a>\
							</div>\
							</div>';
						$(noratingsHTML).insertAfter($(this).find('dd.Specialties'));
					}
				});
			}

	
		}
	} */

	// change sticky nav based on scroll up or down for articles
		var iScrollPos = 0;
		$(window).on('scroll', function () {
			var iCurScrollPos = $(this).scrollTop();
			if (iCurScrollPos > iScrollPos) {
				//Scrolling Down
				document.getElementsByTagName("body")[0].classList.add("scroll-down");
				document.getElementsByTagName("body")[0].classList.remove("scroll-up");
			} else {
			   //Scrolling Up
			   document.getElementsByTagName("body")[0].classList.add("scroll-up");
			   document.getElementsByTagName("body")[0].classList.remove("scroll-down");
			}
			iScrollPos = iCurScrollPos;
		});

	// adding odd/even class for styling
	$('#Home #Slot6 .cmspanel:odd').addClass('Even');
	$('#Home #Slot6 .cmspanel:even').addClass('Odd');
	$('#Home #Slot6 .cmspanel:last').addClass('Last');

	if ($('#Slot6 .cmspanel').length == 1) {
		$('#Slot6').addClass('MultiColumnSlot1');
	}
	if ($('#Slot6 .cmspanel').length == 2) {
		$('#Slot6').addClass('MultiColumnSlot2');
	}
	if ($('#Slot6 .cmspanel').length == 3) {
		$('#Slot6').addClass('MultiColumnSlot3');
		$('#Slot6 .cmspanel:nth-child(2)').addClass('MCS3Child2Border');
	}
	if ($('#Slot6 .cmspanel').length == 4) {
		$('#Slot6 .cmspanel:nth-child(2)').addClass('MCS3Child2Border');
		$('#Slot6 .cmspanel:nth-child(3)').addClass('MCS3Child3Border');
	}

	if ($('#Home').length) {
		$('.Slot .ContentInner').each(function () {
			if (isEmpty($(this))) {
				$(this).closest('.Slot').remove();
			}
		});
		$('.Slot .ContentInterior').each(function () {
			if (isEmpty($(this))) {
				$(this).closest('.Slot').remove();
			}
		});
	}

	// ALERT PANEL INITIALIZATION - Multiple execution points for reliability
	var alertInitialized = false;
	var alertInitAttempts = 0;
	
	// Enhanced alert panel display handler with comprehensive content detection
	function showAlertPanel() {
		try {
			var $alertContent = $('#alert-content');
			var $alertWrap = $('#alert-wrap');
			var $cmsPanelContent = $('#alert-content .cmsPanelContent');
			var $cmsPanel = $('#alert-content .cmspanel');
			
			
			// Check if elements exist
			if ($alertWrap.length === 0) {
				console.warn('Alert wrap element not found');
				return false;
			}
			
			if ($alertContent.length === 0) {
				console.warn('Alert content element not found');
				return false;
			}

			
			// Comprehensive content detection
			var hasContent = false;
			var contentSources = [];
			
			// Check for text content in various containers
			if ($cmsPanelContent.length > 0) {
				var panelText = $cmsPanelContent.text().trim();
				if (panelText !== '') {
					hasContent = true;
					contentSources.push('cmsPanelContent: "' + panelText.substring(0, 50) + '..."');
				}
			}
			
			// Check CMS panel but exclude administrative elements
			if ($cmsPanel.length > 0) {
				// Clone the panel and remove CMS administrative elements to check only user content
				var $contentCheck = $cmsPanel.clone();
				$contentCheck.find('.CmsInfoButtonsContainer, .CmsInfoButtonsPanel').remove();
				var cmsText = $contentCheck.text().trim();
				if (cmsText !== '') {
					hasContent = true;
					contentSources.push('cmsPanel: "' + cmsText.substring(0, 50) + '..."');
				}
			}
			
			// Check direct alert content (excluding CMS administrative elements)
			var $alertContentClone = $alertContent.clone();
			$alertContentClone.find('.CmsInfoButtonsContainer, .CmsInfoButtonsPanel').remove();
			var alertText = $alertContentClone.text().trim();
			if (alertText !== '') {
				hasContent = true;
				contentSources.push('alertContent: "' + alertText.substring(0, 50) + '..."');
			}
			
			// Also specifically check for content in BasicPanel divs
			var $basicPanels = $alertContent.find('.BasicPanel');
			if ($basicPanels.length > 0) {
				$basicPanels.each(function() {
					var basicText = $(this).text().trim();
					if (basicText !== '') {
						hasContent = true;
						contentSources.push('BasicPanel: "' + basicText.substring(0, 50) + '..."');
					}
				});
			}
			
			// Check for non-text content (images, videos, etc.) excluding CMS admin elements
			var hasImages = $alertContent.find('img').not('.CmsInfoButtonsContainer img, .CmsInfoButtonsPanel img').length > 0;
			var hasVideos = $alertContent.find('video, iframe').length > 0;
			var hasInputs = $alertContent.find('input, button, select, textarea').not('.CmsInfoButtonsContainer *, .CmsInfoButtonsPanel *').length > 0;
			var hasLinks = $alertContent.find('a').not('.CmsInfoButtonsContainer a, .CmsInfoButtonsPanel a').length > 0;
			var hasOtherElements = $alertContent.find('*').not('script, style, br, .CmsInfoButtonsContainer, .CmsInfoButtonsContainer *, .CmsInfoButtonsPanel, .CmsInfoButtonsPanel *').length > 0;
			
			if (hasImages) {
				hasContent = true;
				contentSources.push('images: ' + $alertContent.find('img').not('.CmsInfoButtonsContainer img, .CmsInfoButtonsPanel img').length);
			}
			if (hasVideos) {
				hasContent = true;
				contentSources.push('videos/iframes: ' + $alertContent.find('video, iframe').length);
			}
			if (hasInputs) {
				hasContent = true;
				contentSources.push('form elements: ' + $alertContent.find('input, button, select, textarea').not('.CmsInfoButtonsContainer *, .CmsInfoButtonsPanel *').length);
			}
			if (hasLinks) {
				hasContent = true;
				contentSources.push('links: ' + $alertContent.find('a').not('.CmsInfoButtonsContainer a, .CmsInfoButtonsPanel a').length);
			}
			

			
			// Show/hide the alert based on content
			if (hasContent) {
				$alertWrap.show();
				$alertWrap.css({
					'display': 'block',
					'visibility': 'visible',
					'opacity': '1'
				});
				// Force a reflow to ensure styles are applied
				$alertWrap[0].offsetHeight;
			} else {
				$alertWrap.hide();
			}
			
			// Verify final state
		
			
			return true;
			
		} catch (error) {
			console.error('Error in showAlertPanel:', error);
			return false;
		}
		
	}
	
	// Alert panel initialization function with error handling
	function initializeAlertPanel() {
		if (alertInitialized) {
			return;
		}
		
		alertInitAttempts++;
		
		try {
			// Initial check with delay to ensure DOM is ready
			setTimeout(function() {
				showAlertPanel();
			}, 100);
			
			// More aggressive retry mechanism for dynamically loaded content
			var alertCheckRetries = 0;
			var maxAlertRetries = 30; // Increased retries for more thorough checking
			var alertCheckInterval = setInterval(function() {
				alertCheckRetries++;
				
				if (alertCheckRetries >= maxAlertRetries) {
					clearInterval(alertCheckInterval);
					return;
				}
				
				var success = showAlertPanel();
				
				// Stop checking if we successfully processed the alert (whether shown or hidden)
				if (success && $('#alert-content').length > 0) {
					clearInterval(alertCheckInterval);
					alertInitialized = true;
				}
			}, 200); // Check every 200ms for faster response
			
			// Also check when content changes (for dynamic content)
			if (typeof MutationObserver !== 'undefined') {
				var alertObserver = new MutationObserver(function(mutations) {
					var shouldCheck = false;
					mutations.forEach(function(mutation) {
						if (mutation.target.id === 'alert-content' || 
							$(mutation.target).closest('#alert-content').length > 0) {
							shouldCheck = true;
						}
					});
					if (shouldCheck) {
						setTimeout(function() {
							showAlertPanel();
						}, 50); // Small delay to ensure content is rendered
					}
				});
				
				// Observe changes to the alert content area
				var alertElement = document.getElementById('alert-content');
				if (alertElement) {
					alertObserver.observe(alertElement, {
						childList: true,
						subtree: true,
						characterData: true
					});
				} else {
				}
			}
			
			
		} catch (error) {
			console.error('Error in initializeAlertPanel:', error);
			// Retry initialization in case of error
			if (alertInitAttempts < 3) {
				setTimeout(initializeAlertPanel, 1000);
			}
		}
	}
	
	// Execute immediately if document is already ready
	if (document.readyState === 'complete' || document.readyState === 'interactive') {
		initializeAlertPanel();
	} else {
	}
	
	// Also initialize on DOMContentLoaded as fallback
	if (document.addEventListener) {
		document.addEventListener('DOMContentLoaded', function() {
			initializeAlertPanel();
		});
	}
	
	// jQuery document ready as additional fallback
	$(document).ready(function() {
		initializeAlertPanel();
	});
	
	// Window load as final fallback
	$(window).on('load', function() {
		initializeAlertPanel();
		initializeAlertPanel();
	});
	
	// Immediate execution with small delay as ultimate fallback
	setTimeout(function() {
		initializeAlertPanel();
	}, 500);

	if ($('#AlertOverlay .cmspanel').length) {
		var AlertOverlay = $.cookie('AlertOverlay');

		var currentDay = new Date();
		var month = currentDay.getMonth() + 1;
		var day = currentDay.getDate();
		var year = currentDay.getFullYear();
		var todayIs = (month + '/' + day + '/' + year);

		if (AlertOverlay != todayIs) {
			$('#AlertOverlay').css('display', 'block');
		}

		$('#AlertOverlay .alertClose').on('click', function () {
			if ($(this).attr('class') == 'alertClose') {
				$('#AlertOverlay').remove();
				$('.overlay').remove(); //remove the overlay style
				setCookie = $.cookie('AlertOverlay', todayIs, { expires: 365, path: '/' });
			}
		});

		if ($('#AlertOverlay').is(':visible')) { //checking to see if alert is showing
			$('#AlertOverlay').before('<div class="overlay"></div>'); //add the overlay div which will dim the rest of the page
			$(".overlay").show();
		}
	}

	graybarNav();	
	mobileNav();
	mainNavFix();	

	/* JumpNav
	----------------------------------------------------------------- */
	var $sticky = $('#LocationJumpNav');
	if (!!$sticky.offset()) { 
		var generalSidebarHeight = $sticky.innerHeight();
		var stickyTop = $sticky.offset().top;
		var stickOffset = 0;

		$(window).on('scroll', function(){ 
		  var windowTop = $(window).scrollTop(); 

		  if (stickyTop < windowTop+stickOffset) {
			  $sticky.css({ position: 'fixed', top: stickOffset}).addClass('Fixed');
		  } else {
			  $sticky.css({position: 'static', top: 'initial'}).removeClass('Fixed');
		  }
		});
	}

	breadCrumbs();	

	/* Smart Panels - Remove Background
	----------------------------------------------------------------- */
	$('.SmartPanel').closest('.cmspanel').addClass('Plain');

	$('#SmartPanelNewsRecent .SPList li .Thumbnail img').each(function() {
		$(this).attr('src', $(this).attr('src').replace('?size=small',''));
	});
	$('#SmartPanelPagesRelated .SPList li .Thumbnail img').each(function() {
		$(this).attr('src', $(this).attr('src').replace('?size=small',''));
	});

	/* I want to Panel
	----------------------------------------------------------------- */
	$('.cmsPanelContent .IWantTo').closest('.cmspanel').addClass('IWantToPanel Plain');
	$('.IWantToPanel li').addClass('ClearFix');

	if($('.cmspanel ul.NewsList.SPList').length) {
		var newsItem = "";
		var panelSize = 3;
		$.ajax({
			url: '/nancy/search/news-media/news/?pagesize='+ (panelSize+1),
			success: function(data) {
				$(data.Results).each(function(i, el) {
					if(i < panelSize) {
						newsItem += "<li class='SPItem ClearFix'><dl>";
						newsItem += "<dt><a href='"+ el.Url +"'target=_blank'>"+ el.Title +"</a></dt>";
						newsItem += "<dd class='Description' ClearFix'><p>" + el.Description + "</p></dd>";
						newsItem += "</dl></li>";
					}
				});
				if(data.Metadata.TotalResultCount && data.Metadata.TotalResultCount > panelSize) {
					$('.cmspanel ul.NewsList.SPList').after("<p class='MoreLink'><a href='/news-media/news-results'>View More</a></p>");
				}
				$('.cmspanel ul.NewsList.SPList').html(newsItem);
			}
		});
	}

	if($('ul#NewsList').length) {
		if(pageNum === undefined) {
			var pageNum = 0;
		}
		getNewsResults(pageNum);
	}

	function getNewsResults(pageNum) {

		var newsItem = '';

		$.ajax({
			type: 'GET',
			url: '/nancy/search/news-media/news/' + pageNum,
			success: function(data) {
			var resultCount = data.Metadata.ResultCount;
			var totalResultCount = data.Metadata.TotalResultCount;
				$(data.Results).each(function(i, el) {
					newsItem += "<li class='SPItem ClearFix'><dl>";
					newsItem += "<dt><a href='"+ el.Url +"'target=_blank'>"+ el.Title +"</a></dt>";
					newsItem += "<dd class='Description' ClearFix'><p>" + el.Description + "</p></dd>";
					newsItem += "</dl></li>";
				});
				$('ul#NewsList').html(newsItem);

				// Add pagination.
				if(totalResultCount > resultCount) {
					$('.Pagination').empty();
					$('.PaginationRight').remove();
					$('.Pagination').append('<label for="TopPaging" class="Hide">Go to Page</label><span class="page-text">Page: </span>');
					$('.Pagination').append('<select class="SuperShort" name="Pagination" id="TopPaging"></select>');

					// How many pages?
					var numberOfPages = Math.ceil(totalResultCount / resultCount);
					for(var i = 1; i <= numberOfPages; i++) {
						var isSelected = (pageNum === i) ? 'disabled selected' : '';
						$('.Pagination select').append('<option class="pagination-item" ' + isSelected + ' label="' + i + '">' + i + '</option>');
					}

					var resultsFrom = (data.Criteria.PageStart + 1);
					var resultsTo = (data.Criteria.PageStart + data.Results.length);

					$('.Pagination').append('<span class="page-text"> of ' + numberOfPages + ', showing results ' + resultsFrom + '-' + resultsTo + ' of ' + totalResultCount + '</span>');

					// Add Previous / Next.
					$('.Pagination').after('<div class="PaginationRight"><div class="BackNext"><a href="" class="Previous" data-nav="' + (data.Criteria.PageNumber) + '" title="Go to the previous page of pages in the list.">Previous</a> <a href="" class="Next" data-nav="' + (data.Criteria.PageNumber +2) + '" title="Go to the next page of pages in the list.">Next</a></div></div>');

					// Hide buttons if first or last page.
					if(data.Criteria.PageNumber === 0) {
						$('.PaginationRight .Previous').hide();
					} else if(data.Criteria.PageNumber +1 === numberOfPages) {
						$('.PaginationRight .Next').hide();
					}

					// Change Id of second pagination.
					$('#NewsResults label:eq(1)').attr('for', 'BottomPaging');
					$('#NewsResults select:eq(1)').attr('id', 'BottomPaging');

					$('.PaginationRight .BackNext a').on('click', function(e) {
						e.preventDefault();
						var pageNum = parseInt($(this).attr('data-nav'));
						doNavigation(pageNum);
					});

					$('.Pagination select').on('change', function() {
						var pageNum = parseInt($(this).val());
						doNavigation(pageNum);
					});
				}
			}
		});

		function doNavigation(pageNum) {
			getNewsResults(pageNum);
			var position = $("#NewsResults").offset().top - 15;
			$("html, body").animate({ scrollTop: position }, 300);
		}

	}

	/* Task Menu
	----------------------------------------------------------------- */
	// Count number of list items in TaskMenu
	var TaskMenuItems = $('.TaskMenu li').length;
	//Change number of items to a word
	if (TaskMenuItems == 6) {
		TaskMenuItems = 'Six';
	}
	if (TaskMenuItems == 5) {
		TaskMenuItems = 'Five';
	}
	if (TaskMenuItems == 4) {
		TaskMenuItems = 'Four';
	}
	// Apply class to TaskMenu and style with css
	$('.TaskMenu').addClass(TaskMenuItems);

	//Breaking homepage calendar smart panel into two lists
	if ($('.TaskMenu').length > 0) {
		$('.TaskMenu').easyListSplitter({
			colNumber: 2,
			direction: 'vertical'
		});
	}

	/* Children's Panels
	----------------------------------------------------------------- */
	$('.Childrens #LeftColumnPanels .cmspanel, .Childrens #RightColumnPanels .cmspanel, .Childrens #CallToAction .cmspanel').each(function () {
		if (!$(this).find('.SmartPanel, .IWantTo').length > 0) {
			$(this).append('<div class="Pink"></div><div class="Yellow"></div><div class="Red"></div><div class="Blue"></div>');
		}
	});	
	
	callToActionAdjust();
	

	/* Add VideoContainer around iframed YouTube videos
   ----------------------------------------------------------------- */
	$('iframe[src*="youtube.com"], iframe[src*="youtube-nocookie.com"]').each(function () {
		$(this).wrap('<div class="VideoContainer" />');
	});

	// function getFlexSliderSpeed() {
	// 	if ($('.flexslider').attr('data-speed')) {
	// 		return $('.flexslider').attr('data-speed');
	// 	} else {
	// 		return 7000;
	// 	}
	// }

	/*  YouTube Playlist function
	----------------------------------------------------------------- */
	$('.PlaylistContainer').each(function () {

		$.each($(".PlaylistContainer > #ytvideo"), function (index, value) {
			var num = index + 1;
			$(value).attr("id", "ytvideo" + num);
		});

		$.each($(".PlaylistContainer > ul"), function (index, value) {
			var num = index + 1;
			$(value).attr("class", "ytplaylist" + num);
		});

		// You can have up to 8 YouTube playlists on a page. If you need more you will need to add more lines here.
		$("ul.ytplaylist1").ytplaylist({
			addThumbs: true,
			holderId: 'ytvideo1'
		});
		$("ul.ytplaylist2").ytplaylist({
			addThumbs: true,
			holderId: 'ytvideo2'
		});
		$("ul.ytplaylist3").ytplaylist({
			addThumbs: true,
			holderId: 'ytvideo3'
		});
		$("ul.ytplaylist4").ytplaylist({
			addThumbs: true,
			holderId: 'ytvideo4'
		});
		$("ul.ytplaylist5").ytplaylist({
			addThumbs: true,
			holderId: 'ytvideo5'
		});
		$("ul.ytplaylist6").ytplaylist({
			addThumbs: true,
			holderId: 'ytvideo6'
		});
		$("ul.ytplaylist7").ytplaylist({
			addThumbs: true,
			holderId: 'ytvideo7'
		});
		$("ul.ytplaylist8").ytplaylist({
			addThumbs: true,
			holderId: 'ytvideo8'
		});
	});


	/* add Tags to bottom of interior Recipe Hub pages or any page with div class "Tags"
	 * ----------------------------------------------------------------- */
	if ($('.HubTags').length > 0) {
		relatedTags();
		relatedHealthyTags();
	}

	/* add Print button to Recipes
	 * ----------------------------------------------------------------- */

	$('.Recipe').prepend('<button class="Button Right PrintRecipe">Print Recipe</button>');
	/*$('.Recipe').prepend('<img class="HiddenLogo" style="float:right;" alt="UNC Healthcare Recipes" src="/imgs/balance.svg" width="150" />');*/
	$('.Recipe').wrap('<div class="RecipeWrapper"></div>');


	$('button.PrintRecipe').on('click', function () {
		var divToPrint = $(this).parents('.RecipeWrapper').html();
		var newWin = window.open('', 'Print-Window');
		newWin.document.open();
		newWin.document.write('<html>' +
			'<head>' +
			'<style>' +
			'.PrintRecipe { display: none; }' +
			'.Recipe { font-family:Verdana, sans-serif; background: #f2f2f2; padding: 20px; border: 1px solid #c9c9c9 ;margin-bottom: 2em; }' +
			'.Recipe .Right {float: right;}' +
			'.Recipe ul { list-style: none; padding-left: 0; margin-left: 0; }' +
			'.Recipe h2 { border-bottom: 1px solid #56a0d3; }' +
			'.Recipe .TwoCol { float: left; width: 50%; margin-top: 0;};' +
			'.Recipe ul li {padding: 0 0 1.25em !important;}' +
			'.Recipe ol { counter-reset: item; list-style: none; margin-left: 1.875em; padding-left: 1.875em; margin-top: .5em; }' +
			'.Recipe ol li { padding-bottom: 1.5em; }' +
			'.Recipe ol li:before { width: 30px;height: 30px;line-height: 30px;-webkit-border-radius: 50%;-moz-border-radius: 50%;border-radius: 50%;text-align: center;counter-increment: item;position: absolute;border: 1px solid #ccc;color: #777;content: counter(item) "";margin: -6px 0 0 -2.5em;} ' +
			'</style>' +
			'</head>' +
			'<body onload="window.print()">' + divToPrint + '</body></html>');
		newWin.document.close();
		setTimeout(function () { newWin.close(); }, 10);
	});
	
	/*  Lightbox
    ----------------------------------------------------------------- */
	$("a.YouTubeVideo").modaal({ type: 'video' }); // .YouTubeVideo also adds the video icon overtop of the image inside this link
	$("a.Lightbox-for-image").modaal({ type: 'image' });
	$("a.Lightbox-for-video").modaal({ type: 'video' });
	$("a.Lightbox-for-iframe").modaal({
		type: 'iframe',
		width: 1000
	});

	if (!$('body').is('.Campaign')) {
		$('<span class="YouTubeVideoButton" />').insertAfter('a.YouTubeVideo img');
	}

	proximityMobileToggle();

	/*  Locations Module
	----------------------------------------------------------------- */
	if ($('.LocationsList').length > 0) {
		$('.LocationsList > ul > li').each(function () {
			$(this).addClass('ClearFix');
			var Phone = $(this).find('.Phone').html();
			if (Phone === undefined || Phone === null) {
				$(this).find('.Headline').after('<div class="MovedPhone"></div>');
			} else {
				$(this).find('.Headline').after('<div class="MovedPhone">' + Phone + '</div>');
			}
			$(this).find('.Phone').remove();
			$(this).find('.MajorDetails').after($(this).find('.MinorDetails'));
			$(this).find('.Headline,.MovedPhone').wrapAll('<div class="NamePhone" />');
			$(this).find('.MajorDetails,.MinorDetails').wrapAll('<div class="Details" />');
		});
	}

	// Locations Detail Page
	$('#LocationsDetail h3.Heading:contains("Service")').closest('div').addClass('ServiceLine');
	$('#LocationsDetail h3.Heading:contains("Location")').closest('div').addClass('LocationType');

	if ($('.ServiceLine').length > 0 && $('.LocationType').length > 0) {
		$('.ServiceLine, .LocationType').wrapAll('<div class="ClearFix" />');
	}

	// Locations Smart Panel
	// Move Location Thumbnail image into it's own div
	$('#SmartPanelLocations .LocationList li').each(function () {
		var LocationThumb = $(this).find('dd.Picture').html();
		$(this).prepend('<div class="Picture">' + LocationThumb + '</div>');
		$(this).find('dd.Picture').remove();
	});

	//Breaking homepage calendar smart panel into two lists
	if ($('.ContentLeft').length > 0) {
		$('.ContentLeft ul.SPList').easyListSplitter({
			colNumber: 2,
			direction: 'horizontal'
		});
	}

	//Breaking homepage calendar smart panel into two lists
	if ($('.ContentLeft').length > 0) {
		$('#LocationsDetail .ServiceLine ul').easyListSplitter({
			colNumber: 2,
			direction: 'horizontal'
		});
	}

	/* Pull Doctor Video Link into Dr Search Results and Open Video in LightBox
	----------------------------------------------------------------- */
	setTimeout(function () {
		$('#DrResults .HasVideo strong').each(function (i, el) {
			var drURL = $(this).closest('li.Profile').find('dl dt a').attr('href');
			var drID = drURL.split('id=')[1];
			// so we don't see a blink
			$(el).hide();

			$.getProviderById({
				providerId: drID,
				fields: "Videos"
			}, function (data) {
				addLink(el, data.Value.Videos[0]);
				$(el).show();
			});
		});
	}, 50);

	function addLink(el, url) {
		url = url.split('.be/');
		$(el).wrapInner('<span />').wrapInner('<a class="ProviderVideo" href="//www.youtube-nocookie.com/embed/' + url[1] + '?autoplay=1" />');

		$('a.ProviderVideo', el).fancybox({
			'transitionIn': 'elastic',
			'transitionOut': 'elastic',
			'autoscale': true,
			'overlayColor': '#1f1f1f',
			'titleShow': true,
			'titlePosition': 'outside',
			'type': 'iframe'
		});
	}

	/*  CheerCards
	----------------------------------------------------------------- */
	$('.CheerPersonalize .Column:contains("Recipient")').addClass('Recipient');

	/* Site Search
	----------------------------------------------------------------- */
	$('#SiteSearchContainer .SearchInputs').addClass('ClearFix');

	/* The fieldset around the search is unnecessary and since the legend tag is empty it throws an error, so removing these
	----------------------------------------------------------------- */
	$('#Search fieldset, .SearchBox fieldset').contents().unwrap();
	$('#Search legend, .SearchBox legend.Hide').remove();

	/* Forms and Documents
	----------------------------------------------------------------- */
	$('#FormsAndDocuments .ResultsList li').addClass('ClearFix');

	/* Wait Times
	----------------------------------------------------------------- */
	// Break Time into Time and Date spans

	$('.ERWTRow span:first-child').addClass('Name');
	$('.ERWTRow').each(function () {
		var WaitTime = $(this).find('.Time').html();
		// Split at <br>, but must use regex because IE8 uses <BR> not <br>
		var WaitTimeSplit = WaitTime.split(/<br[^>]*>/gi);
		if(WaitTimeSplit[1] && WaitTimeSplit[1] !== 'undefined') {
			$(this).find('.Time').replaceWith('<span class="Time">' + WaitTimeSplit[0] + '</span><span class="Date">' + WaitTimeSplit[1] + '</span>');
		}
	});
	if ($('.CustomProfile #LocationCTA .ClockWiseWaitTimeWrapper .WaitTimeLabel').length) {
		$('.CustomProfile #LocationCTA .ClockWiseWaitTimeWrapper .WaitTimeLabel').prependTo('.CustomProfile #LocationCTA .ClockWiseWaitTimeWrapper .clockwiseWaitTime .ERWTRow');
	}

	/* System Pages
	----------------------------------------------------------------- */
	/* System Homepage Background Image */
	if ($('#SystemHome #Banner .cmspanel').length > 0) {
		var BgImage = $('#SystemHome #Banner .cmspanel:first-child .BasicPanel img').attr('src');
		$('#SystemHome #Banner .cmspanel:first-child').remove();
		$('#SystemHome #BannerWrap').css({
			'background': 'url(' + BgImage + ') center no-repeat',
		});
	}
	/* System Homepage Banner */
	if ($('#SystemHome #Banner').length > 0) {
		$('#SystemHome #Banner li:first-child').addClass("One");
		$('#SystemHome #Banner li:nth-child(2)').addClass('Two');
		$('#SystemHome #Banner li:nth-child(3)').addClass('Three');
		$('#SystemHome #Banner li:nth-child(4)').addClass('Four');
	}

	/* System Homepage Awards Panel */
	if ($('.System .cmsPanelContent .Award').length) {
		$('.System .cmsPanelContent .Award:last').addClass('Last');

	}

	var bmicomment = "";
	var bmianswer = "0";

	// Calculate BMI
	$('#CalBMI').on('click', function () {

		function mod(div, base) {
			return Math.round(div - (Math.floor(div / base) * base));
		}

		var w = $('.BMIWeight').val() * 1;
		var HeightFeetInt = $('.BMIhtf').val() * 1;
		var HeightInchesInt = $('.BMIhti').val() * 1;
		var HeightFeetConvert = HeightFeetInt * 12;
		var h = HeightFeetConvert + HeightInchesInt;
		var displaybmi = (Math.round((w * 703) / (h * h)));
		var rvalue = true;

		if ((w <= 35) || (w >= 500) || (h <= 48) || (h >= 120)) {
			alert("The weight or height you entered is not supported by this calculator. This tool is accurate for heights between 4 feet 10 inches and 7 feet 0 inches and excludes pregnant women, children and atheletes.");
			rvalue = false;
		}
		if (rvalue) {
			$('.BMIInput').addClass('Hide');
			$('.BMIResults').addClass('Show');
			if (HeightInchesInt > 11) {
				var reminderinches = mod(HeightInchesInt, 12);
				$('.BMIhti').val(reminderinches);
				$('.BMIhtf').val(HeightFeetInt + ((HeightInchesInt - reminderinches) / 12));
				//$('.BMIanswer').append(displaybmi);
			}
			if (displaybmi < 19) {
				bmicomment = "Underweight";
			}
			else if (displaybmi >= 19 && displaybmi <= 25) {
				bmicomment = "Desirable";
			}
			else if (displaybmi >= 26 && displaybmi <= 29) {
				bmicomment = "Overweight, prone to health risks";
			}
			else if (displaybmi >= 30 && displaybmi <= 40) {
				bmicomment = "Obese";
			}
			else if (displaybmi > 40) {
				bmicomment = "Extremely obese";
			}
			else {
				bmicomment = "Error, please try again";
			}
			$('.BMIanswer').append(displaybmi);
			$('.BMIcomment').append(bmicomment);
		}
		return rvalue;

	});

	// Reset BMI Calculator
	$('#ResetBMI').on('click', function () {
		$('.BMIInput').removeClass('Hide');
		$('.BMIResults').removeClass('Show');
		bmicomment = "";
		bmianswer = 0;
		$('.BMIanswer').empty();
		$('.BMIcomment').empty();
	});

	// McLendon Labs Site Search
	// Adding class to SiteSearchContainer so that we can hide tabs in the css
	if ($('.cmspage #SiteSearchContainer') && $('.cmsPageContent .Hide #McLendonLabs').length) {
		$('#SiteSearchContainer .Tabnav li').each(function () {
			var TabText = $(this).text();
			if (TabText === "Health Library") {
				$(this).remove();
			}
			if (TabText === "Doctors") {
				$(this).remove();
			}
			if (TabText === "Events") {
				$(this).remove();
			}
			if (TabText === "Locations") {
				$(this).remove();
			}
			if (TabText === "Services") {
				$(this).remove();
			}
		});
		$('#SiteSearchContainer .TabFake .Group').each(function () {
			var GroupText = $(this).find('h2').text();
			if (GroupText === "Related Providers") {
				$(this).closest('.Group').remove();
			}
			if (GroupText === "Related Events") {
				$(this).closest('.Group').remove();
			}
			if (GroupText === "Related Locations") {
				$(this).closest('.Group').remove();
			}
			if (GroupText === "Related services") {
				$(this).closest('.Group').remove();
			}
		});
	}

	// Forms & Documents search page on McLendon Labs site root
	if ($('.cmspage #FormsAndDocuments') && $('.cmsPageContent .McLendonLabs').length) {
		$('#FormsAndDocuments .SearchBox').remove();
		$('.cmsPageContent').append('<iframe src="/mclendon-clinical-laboratories/blank-template-site-search/" width="100%" height="100px" frameborder="0" style="margin-top:20px;"></iframe>');
	}
	if ($('#BlankTemplateSiteSearch').length) {
		$('#PanelMcLendonLabsSiteSearchPanel .SearchContainer').append('<div class="Search">' +
			'<form action="/mclendon-clinical-laboratories/site-search-results/" target="_top" method="get" onsubmit="javascript:if(($id(\'SearchInput\').value.length > 0) &amp;&amp; ($id(\'SearchInput\').value != \'Search\')) {return true;} else {alert(\'Please enter a search term.\');$id(\'SearchInput\').focus();return false;}">' +
			'<fieldset>' +
			'<legend class="Hide"></legend>' +
			'<input type="hidden" name="navigationNode" value="/1/48/1/"/>' +
			'<label class="Hide" for="SearchInput">Search</label>' +
			'<input maxlength="128" id="SearchInput" name="term" type="text" value="Search" onfocus="javascript:if(this.value===\'Search\') {this.value=\'\';}" onblur="javascript:if (this.value==\'\') {this.value=\'Search\';}"/>' +
			'<input type="image" alt="Search" class="ImgButton" src="../../imgs/icons/search-button.gif" onclick="breakout_of_frame()" />' +
			'</fieldset>' +
			'</form>' +
			'</div>');
	}

	// Forms & Documents
	$('#FormsAndDocuments .ResultList li').each(function () {
		var LinkType = $(this).find('.DocumentName img').attr('src');
		if (LinkType.indexOf("/imgs/icons/filetypes/htm.gif") >= 0) {
			$(this).addClass("JustLink");
		}
		$(this).find('.ShowDetails').remove();
		$(this).find('.DocumentDetails').remove();
	});
	$('#FormsAndDocuments .ResultList li.JustLink').each(function () {
		$(this).find('img').remove();
	});

	if ($('body').is('.Campaign')) {
		var destination = 0;
		//add 'back to top' arrow to main nav
		$('body.Campaign #MainNav ul').prepend('<li id="BackToTop"><a href="javascript:void(0)">Scroll to top<span></span></a></li>');

		$('#MainNav ul li a').on('click', function () {
			if ($(this).parent().index() > 0) { //find out if we clicked on the up arrow in the main nav
				if ($('nav').is('.Fixed')) {
					destination = $($(this).attr('href')).offset().top;
				} else {
					destination = $($(this).attr('href')).offset().top - $('nav').height();
				}
			} else {
				destination = 0;
			}

			$('html, body').stop().animate({
				scrollTop: destination
			}, 700, function () {});
			return false;
		});

		$('body.Campaign .cmsPageContent .section').each(function () {
			//Campaign Landing background images
			$(this).css('background', 'url("' + $(this).find('img.BgImg').attr('src') + '") no-repeat center');
			$(this).find('img.BgImg').remove();
		});

		//animate the mobile menu icon and toggle the navigation
		$('body.Campaign #MobileMenuWrapper').on('click', function () {
			$(this).toggleClass('ActiveButton'); //this does the css transition to animate the menu icon
			$('#MobileMenu').slideToggle();
		});

		//change the href's on the main nav
		$('#MainNav ul li a span').each(function () {
			//add an href to be able to scroll down the page smoothly
			$(this).parent().attr('href', '#' + $(this).text().split(' ').join(''));
			if ($(this).text().length > 0) {
				//dynamically add GA code to each nav link
				$(this).parent().attr("onClick", "ga('send', 'event', { eventCategory: 'Complete Care landing page', eventAction: 'click', eventLabel: 'Main Navigation: " + $(this).text() + "'});");
			}
		});

		//add the id's to all of the sections
		$('.cmsPageContent .section .ContentWrap > h2').each(function () {
			$(this).parents('div.section').attr('id', $(this).text().split(' ').join(''));
		});

		/*  This is used for the map near the top of the campaign landing page. The user will specify two images in the panel. One to be used for desktop and another will be used for mobile.
		The plugin 'responsive-img.min' was used.
		This is the markup that will be added in the panel:
		<img data-src-sm="/app/files/public/campaign-landing-map-mobile.jpg" src="/app/files/public/map.png" alt="">
		The markup below will be generated:
		<img data-src="<572:/app/files/public/campaign-landing-map-mobile.jpg,>573:/app/files/public/map.png" alt="" src="/app/files/public/map.png"> */

		if ($('#Map img').attr('data-src-sm') !== 'undefined') {
			var img = $('#Map .cmsPanelContent img').attr('src');
			var smImg = $('#Map .cmsPanelContent img').attr('data-src-sm');
			$('#Map .cmsPanelContent > p img').parent().html('<img alt="" data-src="<572:' + smImg + ',>573:' + img + '" />');
		}

		/* Sticky Nav for Campaign Landing page
		----------------------------------------------------------------- */
		setTimeout(function () {
			if (!navigator.userAgent.match(/silk/i)) {
				var stickyNavTop = $("nav").offset().top;
				var stickyNav = function () {
					var scrollTop = $(window).scrollTop();
					//console.log(scrollTop + " > " + stickyNavTop);
					if (scrollTop > stickyNavTop) {
						$('.Campaign nav').addClass('Fixed');
					} else {
						$('.Campaign nav').removeClass('Fixed');
					}
				};
				stickyNav();

				$(window).on('scroll', function () {
					stickyNav();
				});
			}
		}, 500);
	} // end of campaign landing section

	// UNCPN Templates
	if ($('body').is('.uncpn')) {
		/* UNCPN Practice Location Template has it's own .js file. Look in scripts/uncpn-locations.js for things specific to that template */

		// Site Search - Pop Modal
		$('#SiteSearchButton, #SiteSearchButtonMobile').on('click', function () {
			$('#SearchModal').toggleClass('Hidden');
			$('#Search #SearchInput').focus();
			$('#BodyWrap').attr('aria-hidden', 'true').attr('tab-index', '-1');
			$(this).addClass('Inactive');
		});

		$('#modal-close').on('click', function () {
			$('#SearchModal').toggleClass('Hidden');
			$('#BodyWrap').removeAttr('aria-hidden').attr('tab-index', '0');
			if ($('body').hasClass('Default')) {
				$('#SiteSearchButton').removeClass('Inactive');
			} else {
				$('#SiteSearchButtonMobile').removeClass('Inactive');
			}
		});

		// Call To Action - blue Header styles
		if ($('#CallToAction .BlueHeader').length) {
			$('#CallToAction .BlueHeader').insertBefore('#CallToAction .cmsPanelContent');
			$('#CallToAction .cmsPanelContent').addClass('SmallTopMargin');
		}


		/* Sticky Menu for UNCPN (Except Practice Locations ) 
		----------------------------------------------------------------- */
		var $window = $(window),
			$navigation = $("#HeaderWrap"),
			offsetnav = $navigation.parent('#HeaderOuterWrap').offset(),
			navHeight = $navigation.outerHeight();

		$window.on('scroll', function () {
			if (($window.scrollTop() > offsetnav.top) && $('.Default').length) {
				$navigation.addClass('Fixed');
				$('#HeaderOuterWrap').css('height', navHeight - 10);
			} else {
				$navigation.removeClass('Fixed');
				$('#HeaderOuterWrap').removeAttr('style');
			}
		});
	} // END UNCPN Templates

	graybarTrigger();	

	TabsToAccordions();

	// Hack List Start

	/* Accordion Keyboard Accessibility Fix 
	$('.Accordion .Trigger').each(function() {
		$(this).attr('tabindex', '0');
	});
	$('.Accordion .Trigger').each(function() {
		var yourDiv = $(this);
		var yourSpan = $('<button class="Trigger" role="tab" aria-selected="false" tabindex="0" />');
		yourDiv.before(yourSpan);
		yourSpan.append(yourDiv.children());
		yourDiv.remove();
	});*/
	
	// $('.Accordion .Trigger').each(function () {
	// 	var triggerText = $(this).text();
	// 	//$(this).html('<button class="Trigger" role="tab" aria-selected="false" tabindex="0">' + triggerText +'</button>');
	// 	//$('button.Trigger').unwrap();
	// 	$(this).contents().unwrap().wrap('<button class="Trigger" role="tab" aria-selected="false" tabindex="0" />');
	// });

	$('.Accordion .Trigger').each(function () {
		var isActive = $(this).hasClass('Active');
		$(this).contents().unwrap().wrap('<button class="Trigger ' + (isActive ? 'Active' : '') + '" role="tab" aria-selected="' + isActive + '" tabindex="0" />');
	});

	$('.Accordion').each(function () {
		$(this).attr('role', 'tablist');
	});

	$('.Accordion .Payload').each(function () {
		$(this).attr('role', 'tabpanel').attr('aria-expanded', 'false').attr('aria-hidden', 'true');
	});

	$('.Accordion .Trigger').on('click', function () {
		$('.Accordion .Trigger').attr('aria-selected', 'false');
		$(this).attr('aria-selected', 'true');
		return false;
	});

	//GA Tracking on Related Providers View More, and Related Locations View More.
	if ($('#PanelSmartPanelRelatedLocations .MoreLink a').length > 0) {
		$('#PanelSmartPanelRelatedLocations .MoreLink a').attr('onClick', "ga('send', 'event', 'View More Locations', 'Click Event');");
	}
	if ($('#PanelSmartPanelRelatedPhysicians .MoreLink a').length > 0) {
		$('#PanelSmartPanelRelatedPhysicians .MoreLink a').attr('onClick', "ga('send', 'event', 'View More Providers', 'Click Event');");
	}
	// Hack List End


	//if you need to call it at page load to resize elements etc.
	$(window).on("load", function () {
		CreateQualityReports();
	});
	
	if($('.TwoColumns').length > 0) {
		if(Math.max($(window).width(), window.innerWidth) < 500) {
			$('.TwoColumns').columnize({columns:1});
		} else {
			$('.TwoColumns').columnize({columns:2});
		}
	}
	if($('.ERWTRow').length > 0) {
		formatWaitTimes();
	}

	/* Dr Results */
	$('#DrResults .DrList li .Picture img').each(function () {
		var thisImage = $(this).attr('src').split('?');
		$(this).attr('src', thisImage[0]);
	});

	/* adding from AMP audit 
	----------------------------------------------------------------- */
	$('.Slider').attr('aria-live', 'polite');

	$('#alert-content').attr('aria-live', 'assertive');

}); // end of doc ready

function bannerNoWrap() {
	$('#BannerWrap .BannerNoWrap').each(function(){
		$(this).removeClass('BannerNoWrap');
		$(this).closest('.cmspanel').addClass('BannerNoWrap');
	});

	var src = $('.BannerNoWrap .Image img').attr('src');
	$('.BannerNoWrap').css('background-image', 'url(' + src + ')');
}

// ----------- AFTER PAGE LOAD ------------------//
$(window).on("load", function () {
	// if doctor video has YouTube video wrap with Video Container
	$('#DrDetail iframe.YouTubeVideoPlayer').wrap('<div class="VideoContainer" />');

	//add I Want To HREF value to click event on parent LI
	$('ul.TaskMenu li').on('click', function () {
		var url = $("a", $(this)).attr("href");
		document.location = url;
	});
	
	hasSpecialty();
});

//bind to resize
$(window).on('resize', function() {
	WindowSize();
	moveElements();
	if (!$('body').hasClass('uncpn')) {
		breadArrow();
	}
});


